/* eslint-disable import/prefer-default-export */
import React from 'react';

export const LOGIN_BACKGROUND = (
  <svg
    width="1440"
    height="1024"
    preserveAspectRatio="none"
    viewBox="0 0 1440 1024"
    style={{ height: '100%', width: '100%' }}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_244_1884)">
      <rect width="1440" height="1024" fill="white" />
      <path
        opacity="0.25"
        d="M1149.8 238.881C1149.84 264.743 1144.09 290.358 1132.87 314.253C1121.65 338.147 1105.18 359.85 1084.41 378.113L721.124 698.466L712.506 706.066L560.509 840.093L543.951 854.693L482.371 908.994H-3.6206V785.701L-7 783.737L-4.78645 781.785L-3.6206 780.757L122.212 669.8L132.94 660.34L768.789 99.6607C789.518 81.3802 814.127 66.879 841.212 56.9856C868.297 47.0921 897.327 42 926.644 42C955.961 42 984.991 47.0921 1012.08 56.9856C1039.16 66.879 1063.77 81.3802 1084.5 99.6607C1105.25 117.929 1121.7 139.632 1132.91 163.524C1144.11 187.416 1149.85 213.026 1149.8 238.881V238.881Z"
        stroke="url(#paint0_linear_244_1884)"
        strokeMiterlimit="10"
      />
      <path
        d="M572.414 903.509H566.324C565.629 891.676 564.741 879.854 562.153 868.216C557.601 847.731 546.703 829.511 526.534 818.005C502.219 804.113 472.342 802.13 444.422 806.263C387.482 814.691 338.015 843.592 285.362 862.792C264.234 870.497 241.207 876.792 217.896 879.584C194.161 882.451 170.123 881.637 147.495 874.998C146.716 874.774 145.95 874.539 145.178 874.298C141.238 873.074 137.371 871.673 133.59 870.102C110.254 860.355 92.4987 843.546 74.5701 827.562C62.0039 816.354 48.9485 805.896 33.8974 798.128C26.5461 794.303 18.7271 791.241 10.5933 789.001C0.342524 786.208 -10.281 784.646 -20.9958 784.357V778.83C-0.0355418 779.391 20.4382 784.59 38.5775 793.96L39.9101 794.659C62.2292 806.63 79.1794 824.598 97.8484 840.41C107.395 848.488 117.535 856.078 129.045 861.857C137.611 866.12 146.75 869.395 156.244 871.604C157.087 871.804 157.937 871.999 158.819 872.177C161.428 872.747 164.052 873.24 166.692 873.656C186.41 876.792 205.961 876.185 225.145 873.158C260.745 867.556 295.147 853.665 327.297 839.854C353.221 828.737 379.126 817.317 406.479 809.216C434.875 800.817 465.705 795.646 495.459 801.069C519.832 805.512 542.859 817.741 555.85 836.999C567.29 853.957 570.258 874.098 571.771 893.476C572.041 896.807 572.221 900.155 572.414 903.509Z"
        fill="#FF9B00"
      />
      <path
        d="M629.454 908.304H628.101C627.817 906.894 627.527 905.483 627.234 904.073C626.418 900.113 625.563 896.164 624.644 892.256C611.403 835.869 586.584 796.446 550.877 775.077C488.815 737.926 408.382 761.675 376.682 773.608C346.926 784.808 318.516 799.547 291.006 814.166L283.467 818.201C260.396 830.479 236.547 843.184 212.066 853.888C195.138 861.353 177.588 867.605 159.578 872.588C155.899 873.591 152.168 874.536 148.384 875.424C111.203 884.146 69.7945 886.67 30.7965 873.504C13.3387 867.613 -2.89457 858.788 -18.5346 849.478L-19.9952 848.608L-19.0384 847.743L-18.5346 848.043C-2.72873 857.474 13.6576 866.437 31.2558 872.38C69.2714 885.212 109.641 883.016 146.068 874.721C149.768 873.879 153.425 872.976 157.039 872.011C175.732 866.964 193.935 860.54 211.467 852.805C235.902 842.123 259.726 829.436 282.771 817.163C286.735 815.053 290.715 812.94 294.712 810.822C320.864 796.953 347.902 783.153 376.152 772.524C408.044 760.511 488.994 736.623 551.598 774.098C587.598 795.645 612.608 835.321 625.926 892.025C626.864 896.02 627.738 900.055 628.567 904.096C628.886 905.497 629.173 906.892 629.454 908.304Z"
        fill="url(#paint1_linear_244_1884)"
      />
      <path d="M1440 772.117L-0.99585 909.564V1220H1440V772.117Z" fill="#70CEA1" />
      <path d="M1440 800.889L-0.99585 938.336V1220H1440V800.889Z" fill="#333333" />
      <g opacity="0.62">
        <path
          opacity="0.62"
          d="M90.2159 216.159C91.4397 216.159 92.4318 215.167 92.4318 213.943C92.4318 212.719 91.4397 211.726 90.2159 211.726C88.9921 211.726 88 212.719 88 213.943C88 215.167 88.9921 216.159 90.2159 216.159Z"
          fill="#80CE9D"
        />
        <path
          opacity="0.62"
          d="M122.27 216.159C123.494 216.159 124.486 215.167 124.486 213.943C124.486 212.719 123.494 211.726 122.27 211.726C121.047 211.726 120.055 212.719 120.055 213.943C120.055 215.167 121.047 216.159 122.27 216.159Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M154.325 216.159C155.549 216.159 156.541 215.167 156.541 213.943C156.541 212.719 155.549 211.726 154.325 211.726C153.101 211.726 152.109 212.719 152.109 213.943C152.109 215.167 153.101 216.159 154.325 216.159Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M188.596 213.943C188.596 214.531 188.362 215.095 187.947 215.51C187.531 215.926 186.967 216.16 186.38 216.16C186.089 216.16 185.801 216.102 185.533 215.991C185.264 215.879 185.02 215.716 184.815 215.51C184.61 215.304 184.447 215.059 184.337 214.791C184.226 214.522 184.17 214.234 184.171 213.943C184.171 213.356 184.403 212.793 184.817 212.378C185.231 211.963 185.793 211.728 186.38 211.726C186.967 211.726 187.531 211.96 187.947 212.375C188.362 212.791 188.596 213.355 188.596 213.943Z"
          fill="#80CE9D"
        />
        <path
          opacity="0.62"
          d="M218.441 216.159C219.665 216.159 220.657 215.167 220.657 213.943C220.657 212.719 219.665 211.726 218.441 211.726C217.217 211.726 216.225 212.719 216.225 213.943C216.225 215.167 217.217 216.159 218.441 216.159Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M250.503 216.159C251.726 216.159 252.718 215.167 252.718 213.943C252.718 212.719 251.726 211.726 250.503 211.726C249.279 211.726 248.287 212.719 248.287 213.943C248.287 215.167 249.279 216.159 250.503 216.159Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M282.557 216.159C283.781 216.159 284.773 215.167 284.773 213.943C284.773 212.719 283.781 211.726 282.557 211.726C281.333 211.726 280.341 212.719 280.341 213.943C280.341 215.167 281.333 216.159 282.557 216.159Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M314.612 216.159C315.835 216.159 316.828 215.167 316.828 213.943C316.828 212.719 315.835 211.726 314.612 211.726C313.388 211.726 312.396 212.719 312.396 213.943C312.396 215.167 313.388 216.159 314.612 216.159Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M346.673 216.159C347.897 216.159 348.889 215.167 348.889 213.943C348.889 212.719 347.897 211.726 346.673 211.726C345.449 211.726 344.457 212.719 344.457 213.943C344.457 215.167 345.449 216.159 346.673 216.159Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M90.2159 237.716C91.4397 237.716 92.4318 236.723 92.4318 235.499C92.4318 234.275 91.4397 233.282 90.2159 233.282C88.9921 233.282 88 234.275 88 235.499C88 236.723 88.9921 237.716 90.2159 237.716Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M122.27 237.716C123.494 237.716 124.486 236.723 124.486 235.499C124.486 234.275 123.494 233.282 122.27 233.282C121.047 233.282 120.055 234.275 120.055 235.499C120.055 236.723 121.047 237.716 122.27 237.716Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M154.325 237.716C155.549 237.716 156.541 236.723 156.541 235.499C156.541 234.275 155.549 233.282 154.325 233.282C153.101 233.282 152.109 234.275 152.109 235.499C152.109 236.723 153.101 237.716 154.325 237.716Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M188.596 235.499C188.596 236.087 188.362 236.651 187.947 237.066C187.531 237.482 186.967 237.716 186.38 237.716C186.089 237.716 185.801 237.658 185.533 237.547C185.264 237.435 185.02 237.272 184.815 237.066C184.61 236.86 184.447 236.616 184.337 236.347C184.226 236.078 184.17 235.79 184.171 235.499C184.17 235.208 184.226 234.92 184.337 234.651C184.447 234.382 184.61 234.138 184.815 233.932C185.02 233.726 185.264 233.563 185.533 233.451C185.801 233.34 186.089 233.282 186.38 233.282C186.967 233.282 187.531 233.516 187.947 233.932C188.362 234.347 188.596 234.911 188.596 235.499V235.499Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M218.441 237.716C219.665 237.716 220.657 236.723 220.657 235.499C220.657 234.275 219.665 233.282 218.441 233.282C217.217 233.282 216.225 234.275 216.225 235.499C216.225 236.723 217.217 237.716 218.441 237.716Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M250.503 237.716C251.726 237.716 252.718 236.723 252.718 235.499C252.718 234.275 251.726 233.282 250.503 233.282C249.279 233.282 248.287 234.275 248.287 235.499C248.287 236.723 249.279 237.716 250.503 237.716Z"
          fill="#80CE9D"
        />
        <path
          opacity="0.62"
          d="M282.557 237.716C283.781 237.716 284.773 236.723 284.773 235.499C284.773 234.275 283.781 233.282 282.557 233.282C281.333 233.282 280.341 234.275 280.341 235.499C280.341 236.723 281.333 237.716 282.557 237.716Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M314.612 237.716C315.835 237.716 316.828 236.723 316.828 235.499C316.828 234.275 315.835 233.282 314.612 233.282C313.388 233.282 312.396 234.275 312.396 235.499C312.396 236.723 313.388 237.716 314.612 237.716Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M346.673 237.716C347.897 237.716 348.889 236.723 348.889 235.499C348.889 234.275 347.897 233.282 346.673 233.282C345.449 233.282 344.457 234.275 344.457 235.499C344.457 236.723 345.449 237.716 346.673 237.716Z"
          fill="#80CE9D"
        />
        <path
          opacity="0.62"
          d="M90.2159 259.272C91.4397 259.272 92.4318 258.279 92.4318 257.055C92.4318 255.831 91.4397 254.839 90.2159 254.839C88.9921 254.839 88 255.831 88 257.055C88 258.279 88.9921 259.272 90.2159 259.272Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M122.27 259.272C123.494 259.272 124.486 258.279 124.486 257.055C124.486 255.831 123.494 254.839 122.27 254.839C121.047 254.839 120.055 255.831 120.055 257.055C120.055 258.279 121.047 259.272 122.27 259.272Z"
          fill="#80CE9D"
        />
        <path
          opacity="0.62"
          d="M154.325 259.272C155.549 259.272 156.541 258.279 156.541 257.055C156.541 255.831 155.549 254.839 154.325 254.839C153.101 254.839 152.109 255.831 152.109 257.055C152.109 258.279 153.101 259.272 154.325 259.272Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M188.596 257.055C188.596 257.643 188.362 258.207 187.947 258.623C187.531 259.038 186.967 259.272 186.38 259.272C185.793 259.27 185.231 259.035 184.817 258.62C184.403 258.204 184.171 257.642 184.171 257.055C184.17 256.764 184.226 256.476 184.337 256.207C184.447 255.939 184.61 255.694 184.815 255.488C185.02 255.282 185.264 255.119 185.533 255.007C185.801 254.896 186.089 254.838 186.38 254.839C186.967 254.839 187.531 255.072 187.947 255.488C188.362 255.903 188.596 256.467 188.596 257.055Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M218.441 259.272C219.665 259.272 220.657 258.279 220.657 257.055C220.657 255.831 219.665 254.839 218.441 254.839C217.217 254.839 216.225 255.831 216.225 257.055C216.225 258.279 217.217 259.272 218.441 259.272Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M250.503 259.272C251.726 259.272 252.718 258.279 252.718 257.055C252.718 255.831 251.726 254.839 250.503 254.839C249.279 254.839 248.287 255.831 248.287 257.055C248.287 258.279 249.279 259.272 250.503 259.272Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M282.557 259.272C283.781 259.272 284.773 258.279 284.773 257.055C284.773 255.831 283.781 254.839 282.557 254.839C281.333 254.839 280.341 255.831 280.341 257.055C280.341 258.279 281.333 259.272 282.557 259.272Z"
          fill="#80CE9D"
        />
        <path
          opacity="0.62"
          d="M314.612 259.272C315.835 259.272 316.828 258.279 316.828 257.055C316.828 255.831 315.835 254.839 314.612 254.839C313.388 254.839 312.396 255.831 312.396 257.055C312.396 258.279 313.388 259.272 314.612 259.272Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M346.673 259.272C347.897 259.272 348.889 258.279 348.889 257.055C348.889 255.831 347.897 254.839 346.673 254.839C345.449 254.839 344.457 255.831 344.457 257.055C344.457 258.279 345.449 259.272 346.673 259.272Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M90.2159 280.821C91.4397 280.821 92.4318 279.828 92.4318 278.604C92.4318 277.38 91.4397 276.388 90.2159 276.388C88.9921 276.388 88 277.38 88 278.604C88 279.828 88.9921 280.821 90.2159 280.821Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M122.27 280.821C123.494 280.821 124.486 279.828 124.486 278.604C124.486 277.38 123.494 276.388 122.27 276.388C121.047 276.388 120.055 277.38 120.055 278.604C120.055 279.828 121.047 280.821 122.27 280.821Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M154.325 280.821C155.549 280.821 156.541 279.828 156.541 278.604C156.541 277.38 155.549 276.388 154.325 276.388C153.101 276.388 152.109 277.38 152.109 278.604C152.109 279.828 153.101 280.821 154.325 280.821Z"
          fill="#80CE9D"
        />
        <path
          opacity="0.62"
          d="M188.596 278.59C188.596 278.881 188.538 279.169 188.427 279.438C188.315 279.706 188.152 279.95 187.946 280.155C187.74 280.361 187.496 280.523 187.227 280.634C186.958 280.744 186.67 280.801 186.38 280.8C185.794 280.8 185.232 280.567 184.818 280.153C184.403 279.738 184.171 279.176 184.171 278.59C184.17 278.3 184.226 278.012 184.337 277.743C184.447 277.474 184.61 277.229 184.815 277.023C185.02 276.818 185.264 276.654 185.533 276.543C185.801 276.431 186.089 276.374 186.38 276.374C186.967 276.374 187.531 276.607 187.947 277.023C188.362 277.439 188.596 278.003 188.596 278.59Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M218.441 280.821C219.665 280.821 220.657 279.828 220.657 278.604C220.657 277.38 219.665 276.388 218.441 276.388C217.217 276.388 216.225 277.38 216.225 278.604C216.225 279.828 217.217 280.821 218.441 280.821Z"
          fill="#80CE9D"
        />
        <path
          opacity="0.62"
          d="M250.503 280.821C251.726 280.821 252.718 279.828 252.718 278.604C252.718 277.38 251.726 276.388 250.503 276.388C249.279 276.388 248.287 277.38 248.287 278.604C248.287 279.828 249.279 280.821 250.503 280.821Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M282.557 280.821C283.781 280.821 284.773 279.828 284.773 278.604C284.773 277.38 283.781 276.388 282.557 276.388C281.333 276.388 280.341 277.38 280.341 278.604C280.341 279.828 281.333 280.821 282.557 280.821Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M314.612 280.821C315.835 280.821 316.828 279.828 316.828 278.604C316.828 277.38 315.835 276.388 314.612 276.388C313.388 276.388 312.396 277.38 312.396 278.604C312.396 279.828 313.388 280.821 314.612 280.821Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M346.673 280.821C347.897 280.821 348.889 279.828 348.889 278.604C348.889 277.38 347.897 276.388 346.673 276.388C345.449 276.388 344.457 277.38 344.457 278.604C344.457 279.828 345.449 280.821 346.673 280.821Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M502.611 397.35C502.611 397.641 502.554 397.929 502.442 398.198C502.331 398.467 502.168 398.711 501.962 398.917C501.756 399.123 501.512 399.287 501.243 399.398C500.974 399.509 500.686 399.567 500.395 399.567C500.104 399.567 499.816 399.509 499.547 399.398C499.278 399.287 499.034 399.123 498.828 398.917C498.622 398.711 498.459 398.467 498.348 398.198C498.237 397.929 498.179 397.641 498.179 397.35C498.179 397.059 498.237 396.771 498.348 396.503C498.459 396.234 498.623 395.99 498.829 395.785C499.034 395.58 499.279 395.417 499.548 395.307C499.816 395.196 500.104 395.139 500.395 395.14C500.982 395.14 501.544 395.373 501.96 395.787C502.375 396.201 502.609 396.763 502.611 397.35V397.35Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M140.822 93.9087C140.82 94.4953 140.586 95.0574 140.17 95.4716C139.755 95.8858 139.192 96.1184 138.606 96.1184C138.315 96.1194 138.027 96.0628 137.758 95.9522C137.49 95.8416 137.245 95.6789 137.039 95.4736C136.834 95.2683 136.67 95.0245 136.559 94.7559C136.447 94.4874 136.39 94.1994 136.39 93.9087C136.39 93.3208 136.623 92.757 137.039 92.3414C137.455 91.9257 138.018 91.6921 138.606 91.6921C139.194 91.6921 139.757 91.9257 140.173 92.3414C140.588 92.757 140.822 93.3208 140.822 93.9087V93.9087Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M411.932 71.2167C411.932 71.8046 411.698 72.3683 411.283 72.784C410.867 73.1997 410.304 73.4332 409.716 73.4332C409.128 73.4332 408.564 73.1997 408.149 72.784C407.733 72.3683 407.5 71.8046 407.5 71.2167C407.5 70.6288 407.733 70.0649 408.149 69.6492C408.564 69.2335 409.128 69 409.716 69C410.304 69 410.867 69.2335 411.283 69.6492C411.698 70.0649 411.932 70.6288 411.932 71.2167V71.2167Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M152.116 592.643C153.34 592.643 154.332 591.651 154.332 590.427C154.332 589.203 153.34 588.21 152.116 588.21C150.892 588.21 149.9 589.203 149.9 590.427C149.9 591.651 150.892 592.643 152.116 592.643Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M90.2159 302.377C91.4397 302.377 92.4318 301.385 92.4318 300.16C92.4318 298.936 91.4397 297.944 90.2159 297.944C88.9921 297.944 88 298.936 88 300.16C88 301.385 88.9921 302.377 90.2159 302.377Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M122.27 302.377C123.494 302.377 124.486 301.385 124.486 300.16C124.486 298.936 123.494 297.944 122.27 297.944C121.047 297.944 120.055 298.936 120.055 300.16C120.055 301.385 121.047 302.377 122.27 302.377Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M154.325 302.377C155.549 302.377 156.541 301.385 156.541 300.16C156.541 298.936 155.549 297.944 154.325 297.944C153.101 297.944 152.109 298.936 152.109 300.16C152.109 301.385 153.101 302.377 154.325 302.377Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M188.596 300.16C188.596 300.748 188.362 301.312 187.947 301.728C187.531 302.144 186.967 302.377 186.38 302.377C186.089 302.377 185.801 302.32 185.533 302.208C185.264 302.097 185.02 301.933 184.815 301.727C184.61 301.521 184.447 301.277 184.337 301.008C184.226 300.739 184.17 300.451 184.171 300.16C184.171 299.574 184.403 299.012 184.818 298.598C185.232 298.184 185.794 297.951 186.38 297.951C186.67 297.95 186.958 298.006 187.227 298.117C187.496 298.228 187.74 298.39 187.946 298.596C188.152 298.801 188.315 299.045 188.427 299.313C188.538 299.582 188.596 299.87 188.596 300.16V300.16Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M218.441 302.377C219.665 302.377 220.657 301.385 220.657 300.16C220.657 298.936 219.665 297.944 218.441 297.944C217.217 297.944 216.225 298.936 216.225 300.16C216.225 301.385 217.217 302.377 218.441 302.377Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M250.503 302.377C251.726 302.377 252.718 301.385 252.718 300.16C252.718 298.936 251.726 297.944 250.503 297.944C249.279 297.944 248.287 298.936 248.287 300.16C248.287 301.385 249.279 302.377 250.503 302.377Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M282.557 302.377C283.781 302.377 284.773 301.385 284.773 300.16C284.773 298.936 283.781 297.944 282.557 297.944C281.333 297.944 280.341 298.936 280.341 300.16C280.341 301.385 281.333 302.377 282.557 302.377Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M314.612 302.377C315.835 302.377 316.828 301.385 316.828 300.16C316.828 298.936 315.835 297.944 314.612 297.944C313.388 297.944 312.396 298.936 312.396 300.16C312.396 301.385 313.388 302.377 314.612 302.377Z"
          fill="#80CE9D"
        />
        <path
          opacity="0.62"
          d="M346.673 302.377C347.897 302.377 348.889 301.385 348.889 300.16C348.889 298.936 347.897 297.944 346.673 297.944C345.449 297.944 344.457 298.936 344.457 300.16C344.457 301.385 345.449 302.377 346.673 302.377Z"
          fill="#80CE9D"
        />
        <path
          opacity="0.62"
          d="M851.576 574.703C852.799 574.703 853.792 573.711 853.792 572.487C853.792 571.262 852.799 570.27 851.576 570.27C850.352 570.27 849.36 571.262 849.36 572.487C849.36 573.711 850.352 574.703 851.576 574.703Z"
          fill="#80CE9D"
        />
        <path
          opacity="0.62"
          d="M740.233 168.129C740.234 168.42 740.177 168.708 740.067 168.977C739.956 169.246 739.794 169.49 739.588 169.696C739.383 169.902 739.139 170.065 738.871 170.177C738.603 170.288 738.315 170.346 738.024 170.346C737.436 170.346 736.873 170.112 736.457 169.696C736.042 169.281 735.808 168.717 735.808 168.129C735.808 167.541 736.042 166.978 736.457 166.562C736.873 166.146 737.436 165.913 738.024 165.913C738.315 165.913 738.603 165.97 738.871 166.081C739.139 166.193 739.383 166.356 739.588 166.562C739.794 166.768 739.956 167.013 740.067 167.281C740.177 167.55 740.234 167.838 740.233 168.129Z"
          fill="#80CE9D"
        />
      </g>
      <g opacity="0.62">
        <path
          opacity="0.62"
          d="M1258.48 460.216C1258.48 461.44 1259.48 462.432 1260.7 462.432C1261.92 462.432 1262.92 461.44 1262.92 460.216C1262.92 458.992 1261.92 458 1260.7 458C1259.48 458 1258.48 458.992 1258.48 460.216Z"
          fill="#80CE9D"
        />
        <path
          opacity="0.62"
          d="M1258.48 492.27C1258.48 493.494 1259.48 494.486 1260.7 494.486C1261.92 494.486 1262.92 493.494 1262.92 492.27C1262.92 491.047 1261.92 490.055 1260.7 490.055C1259.48 490.055 1258.48 491.047 1258.48 492.27Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M1258.48 524.325C1258.48 525.549 1259.48 526.541 1260.7 526.541C1261.92 526.541 1262.92 525.549 1262.92 524.325C1262.92 523.101 1261.92 522.109 1260.7 522.109C1259.48 522.109 1258.48 523.101 1258.48 524.325Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M1260.7 558.596C1260.11 558.596 1259.55 558.362 1259.13 557.947C1258.72 557.531 1258.48 556.967 1258.48 556.38C1258.48 556.089 1258.54 555.801 1258.65 555.533C1258.76 555.264 1258.93 555.02 1259.13 554.815C1259.34 554.61 1259.58 554.447 1259.85 554.337C1260.12 554.226 1260.41 554.17 1260.7 554.171C1261.29 554.171 1261.85 554.403 1262.27 554.817C1262.68 555.231 1262.92 555.793 1262.92 556.38C1262.92 556.967 1262.68 557.531 1262.27 557.947C1261.85 558.362 1261.29 558.596 1260.7 558.596Z"
          fill="#80CE9D"
        />
        <path
          opacity="0.62"
          d="M1258.48 588.441C1258.48 589.665 1259.48 590.657 1260.7 590.657C1261.92 590.657 1262.92 589.665 1262.92 588.441C1262.92 587.217 1261.92 586.225 1260.7 586.225C1259.48 586.225 1258.48 587.217 1258.48 588.441Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M1258.48 620.503C1258.48 621.726 1259.48 622.718 1260.7 622.718C1261.92 622.718 1262.92 621.726 1262.92 620.503C1262.92 619.279 1261.92 618.287 1260.7 618.287C1259.48 618.287 1258.48 619.279 1258.48 620.503Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M1258.48 652.557C1258.48 653.781 1259.48 654.773 1260.7 654.773C1261.92 654.773 1262.92 653.781 1262.92 652.557C1262.92 651.333 1261.92 650.341 1260.7 650.341C1259.48 650.341 1258.48 651.333 1258.48 652.557Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M1258.48 684.612C1258.48 685.835 1259.48 686.828 1260.7 686.828C1261.92 686.828 1262.92 685.835 1262.92 684.612C1262.92 683.388 1261.92 682.396 1260.7 682.396C1259.48 682.396 1258.48 683.388 1258.48 684.612Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M1258.48 716.673C1258.48 717.897 1259.48 718.889 1260.7 718.889C1261.92 718.889 1262.92 717.897 1262.92 716.673C1262.92 715.449 1261.92 714.457 1260.7 714.457C1259.48 714.457 1258.48 715.449 1258.48 716.673Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M1236.93 460.216C1236.93 461.44 1237.92 462.432 1239.14 462.432C1240.37 462.432 1241.36 461.44 1241.36 460.216C1241.36 458.992 1240.37 458 1239.14 458C1237.92 458 1236.93 458.992 1236.93 460.216Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M1236.93 492.27C1236.93 493.494 1237.92 494.486 1239.14 494.486C1240.37 494.486 1241.36 493.494 1241.36 492.27C1241.36 491.047 1240.37 490.055 1239.14 490.055C1237.92 490.055 1236.93 491.047 1236.93 492.27Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M1236.93 524.325C1236.93 525.549 1237.92 526.541 1239.14 526.541C1240.37 526.541 1241.36 525.549 1241.36 524.325C1241.36 523.101 1240.37 522.109 1239.14 522.109C1237.92 522.109 1236.93 523.101 1236.93 524.325Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M1239.14 558.596C1238.56 558.596 1237.99 558.362 1237.58 557.947C1237.16 557.531 1236.93 556.967 1236.93 556.38C1236.93 556.089 1236.99 555.801 1237.1 555.533C1237.21 555.264 1237.37 555.02 1237.58 554.815C1237.78 554.61 1238.03 554.447 1238.3 554.337C1238.57 554.226 1238.85 554.17 1239.14 554.171C1239.44 554.17 1239.72 554.226 1239.99 554.337C1240.26 554.447 1240.51 554.61 1240.71 554.815C1240.92 555.02 1241.08 555.264 1241.19 555.533C1241.3 555.801 1241.36 556.089 1241.36 556.38C1241.36 556.967 1241.13 557.531 1240.71 557.947C1240.3 558.362 1239.73 558.596 1239.14 558.596V558.596Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M1236.93 588.441C1236.93 589.665 1237.92 590.657 1239.14 590.657C1240.37 590.657 1241.36 589.665 1241.36 588.441C1241.36 587.217 1240.37 586.225 1239.14 586.225C1237.92 586.225 1236.93 587.217 1236.93 588.441Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M1236.93 620.503C1236.93 621.726 1237.92 622.718 1239.14 622.718C1240.37 622.718 1241.36 621.726 1241.36 620.503C1241.36 619.279 1240.37 618.287 1239.14 618.287C1237.92 618.287 1236.93 619.279 1236.93 620.503Z"
          fill="#80CE9D"
        />
        <path
          opacity="0.62"
          d="M1236.93 652.557C1236.93 653.781 1237.92 654.773 1239.14 654.773C1240.37 654.773 1241.36 653.781 1241.36 652.557C1241.36 651.333 1240.37 650.341 1239.14 650.341C1237.92 650.341 1236.93 651.333 1236.93 652.557Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M1236.93 684.612C1236.93 685.835 1237.92 686.828 1239.14 686.828C1240.37 686.828 1241.36 685.835 1241.36 684.612C1241.36 683.388 1240.37 682.396 1239.14 682.396C1237.92 682.396 1236.93 683.388 1236.93 684.612Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M1236.93 716.673C1236.93 717.897 1237.92 718.889 1239.14 718.889C1240.37 718.889 1241.36 717.897 1241.36 716.673C1241.36 715.449 1240.37 714.457 1239.14 714.457C1237.92 714.457 1236.93 715.449 1236.93 716.673Z"
          fill="#80CE9D"
        />
        <path
          opacity="0.62"
          d="M1215.37 460.216C1215.37 461.44 1216.36 462.432 1217.59 462.432C1218.81 462.432 1219.8 461.44 1219.8 460.216C1219.8 458.992 1218.81 458 1217.59 458C1216.36 458 1215.37 458.992 1215.37 460.216Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M1215.37 492.27C1215.37 493.494 1216.36 494.486 1217.59 494.486C1218.81 494.486 1219.8 493.494 1219.8 492.27C1219.8 491.047 1218.81 490.055 1217.59 490.055C1216.36 490.055 1215.37 491.047 1215.37 492.27Z"
          fill="#80CE9D"
        />
        <path
          opacity="0.62"
          d="M1215.37 524.325C1215.37 525.549 1216.36 526.541 1217.59 526.541C1218.81 526.541 1219.8 525.549 1219.8 524.325C1219.8 523.101 1218.81 522.109 1217.59 522.109C1216.36 522.109 1215.37 523.101 1215.37 524.325Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M1217.59 558.596C1217 558.596 1216.44 558.362 1216.02 557.947C1215.61 557.531 1215.37 556.967 1215.37 556.38C1215.37 555.793 1215.61 555.231 1216.02 554.817C1216.44 554.403 1217 554.171 1217.59 554.171C1217.88 554.17 1218.17 554.226 1218.44 554.337C1218.7 554.447 1218.95 554.61 1219.16 554.815C1219.36 555.02 1219.52 555.264 1219.64 555.533C1219.75 555.801 1219.81 556.089 1219.81 556.38C1219.81 556.967 1219.57 557.531 1219.16 557.947C1218.74 558.362 1218.18 558.596 1217.59 558.596Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M1215.37 588.441C1215.37 589.665 1216.36 590.657 1217.59 590.657C1218.81 590.657 1219.8 589.665 1219.8 588.441C1219.8 587.217 1218.81 586.225 1217.59 586.225C1216.36 586.225 1215.37 587.217 1215.37 588.441Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M1215.37 620.503C1215.37 621.726 1216.36 622.718 1217.59 622.718C1218.81 622.718 1219.8 621.726 1219.8 620.503C1219.8 619.279 1218.81 618.287 1217.59 618.287C1216.36 618.287 1215.37 619.279 1215.37 620.503Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M1215.37 652.557C1215.37 653.781 1216.36 654.773 1217.59 654.773C1218.81 654.773 1219.8 653.781 1219.8 652.557C1219.8 651.333 1218.81 650.341 1217.59 650.341C1216.36 650.341 1215.37 651.333 1215.37 652.557Z"
          fill="#80CE9D"
        />
        <path
          opacity="0.62"
          d="M1215.37 684.612C1215.37 685.835 1216.36 686.828 1217.59 686.828C1218.81 686.828 1219.8 685.835 1219.8 684.612C1219.8 683.388 1218.81 682.396 1217.59 682.396C1216.36 682.396 1215.37 683.388 1215.37 684.612Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M1215.37 716.673C1215.37 717.897 1216.36 718.889 1217.59 718.889C1218.81 718.889 1219.8 717.897 1219.8 716.673C1219.8 715.449 1218.81 714.457 1217.59 714.457C1216.36 714.457 1215.37 715.449 1215.37 716.673Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M1193.82 460.216C1193.82 461.44 1194.82 462.432 1196.04 462.432C1197.26 462.432 1198.26 461.44 1198.26 460.216C1198.26 458.992 1197.26 458 1196.04 458C1194.82 458 1193.82 458.992 1193.82 460.216Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M1193.82 492.27C1193.82 493.494 1194.82 494.486 1196.04 494.486C1197.26 494.486 1198.26 493.494 1198.26 492.27C1198.26 491.047 1197.26 490.055 1196.04 490.055C1194.82 490.055 1193.82 491.047 1193.82 492.27Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M1193.82 524.325C1193.82 525.549 1194.82 526.541 1196.04 526.541C1197.26 526.541 1198.26 525.549 1198.26 524.325C1198.26 523.101 1197.26 522.109 1196.04 522.109C1194.82 522.109 1193.82 523.101 1193.82 524.325Z"
          fill="#80CE9D"
        />
        <path
          opacity="0.62"
          d="M1196.05 558.596C1195.76 558.596 1195.47 558.538 1195.21 558.427C1194.94 558.315 1194.69 558.152 1194.49 557.946C1194.28 557.74 1194.12 557.496 1194.01 557.227C1193.9 556.958 1193.84 556.67 1193.84 556.38C1193.84 555.794 1194.08 555.232 1194.49 554.818C1194.91 554.403 1195.47 554.171 1196.05 554.171C1196.34 554.17 1196.63 554.226 1196.9 554.337C1197.17 554.447 1197.41 554.61 1197.62 554.815C1197.83 555.02 1197.99 555.264 1198.1 555.533C1198.21 555.801 1198.27 556.089 1198.27 556.38C1198.27 556.967 1198.04 557.531 1197.62 557.947C1197.2 558.362 1196.64 558.596 1196.05 558.596Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M1193.82 588.441C1193.82 589.665 1194.82 590.657 1196.04 590.657C1197.26 590.657 1198.26 589.665 1198.26 588.441C1198.26 587.217 1197.26 586.225 1196.04 586.225C1194.82 586.225 1193.82 587.217 1193.82 588.441Z"
          fill="#80CE9D"
        />
        <path
          opacity="0.62"
          d="M1193.82 620.503C1193.82 621.726 1194.82 622.718 1196.04 622.718C1197.26 622.718 1198.26 621.726 1198.26 620.503C1198.26 619.279 1197.26 618.287 1196.04 618.287C1194.82 618.287 1193.82 619.279 1193.82 620.503Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M1193.82 652.557C1193.82 653.781 1194.82 654.773 1196.04 654.773C1197.26 654.773 1198.26 653.781 1198.26 652.557C1198.26 651.333 1197.26 650.341 1196.04 650.341C1194.82 650.341 1193.82 651.333 1193.82 652.557Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M1193.82 684.612C1193.82 685.835 1194.82 686.828 1196.04 686.828C1197.26 686.828 1198.26 685.835 1198.26 684.612C1198.26 683.388 1197.26 682.396 1196.04 682.396C1194.82 682.396 1193.82 683.388 1193.82 684.612Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M1193.82 716.673C1193.82 717.897 1194.82 718.889 1196.04 718.889C1197.26 718.889 1198.26 717.897 1198.26 716.673C1198.26 715.449 1197.26 714.457 1196.04 714.457C1194.82 714.457 1193.82 715.449 1193.82 716.673Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M1077.29 872.611C1077 872.611 1076.71 872.554 1076.45 872.442C1076.18 872.331 1075.93 872.168 1075.73 871.962C1075.52 871.756 1075.36 871.512 1075.25 871.243C1075.13 870.974 1075.08 870.686 1075.08 870.395C1075.08 870.104 1075.13 869.816 1075.25 869.547C1075.36 869.278 1075.52 869.034 1075.73 868.828C1075.93 868.623 1076.18 868.459 1076.45 868.348C1076.71 868.237 1077 868.179 1077.29 868.179C1077.58 868.179 1077.87 868.237 1078.14 868.348C1078.41 868.46 1078.65 868.623 1078.86 868.829C1079.06 869.035 1079.23 869.279 1079.34 869.548C1079.45 869.817 1079.5 870.104 1079.5 870.395C1079.5 870.982 1079.27 871.544 1078.86 871.96C1078.44 872.375 1077.88 872.609 1077.29 872.611V872.611Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M1380.73 510.822C1380.15 510.82 1379.59 510.586 1379.17 510.17C1378.76 509.755 1378.53 509.192 1378.53 508.606C1378.52 508.315 1378.58 508.027 1378.69 507.759C1378.8 507.49 1378.96 507.245 1379.17 507.039C1379.38 506.834 1379.62 506.67 1379.89 506.559C1380.16 506.447 1380.44 506.39 1380.73 506.39C1381.32 506.39 1381.89 506.624 1382.3 507.039C1382.72 507.455 1382.95 508.018 1382.95 508.606C1382.95 509.194 1382.72 509.757 1382.3 510.173C1381.89 510.588 1381.32 510.822 1380.73 510.822V510.822Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M1403.43 781.932C1402.84 781.932 1402.28 781.698 1401.86 781.283C1401.44 780.867 1401.21 780.304 1401.21 779.716C1401.21 779.128 1401.44 778.564 1401.86 778.149C1402.28 777.733 1402.84 777.5 1403.43 777.5C1404.01 777.5 1404.58 777.733 1404.99 778.149C1405.41 778.564 1405.64 779.128 1405.64 779.716C1405.64 780.304 1405.41 780.867 1404.99 781.283C1404.58 781.698 1404.01 781.932 1403.43 781.932V781.932Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M882 522.116C882 523.34 882.992 524.332 884.217 524.332C885.441 524.332 886.433 523.34 886.433 522.116C886.433 520.892 885.441 519.9 884.217 519.9C882.992 519.9 882 520.892 882 522.116Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M1172.27 460.216C1172.27 461.44 1173.26 462.432 1174.48 462.432C1175.71 462.432 1176.7 461.44 1176.7 460.216C1176.7 458.992 1175.71 458 1174.48 458C1173.26 458 1172.27 458.992 1172.27 460.216Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M1172.27 492.27C1172.27 493.494 1173.26 494.486 1174.48 494.486C1175.71 494.486 1176.7 493.494 1176.7 492.27C1176.7 491.047 1175.71 490.055 1174.48 490.055C1173.26 490.055 1172.27 491.047 1172.27 492.27Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M1172.27 524.325C1172.27 525.549 1173.26 526.541 1174.48 526.541C1175.71 526.541 1176.7 525.549 1176.7 524.325C1176.7 523.101 1175.71 522.109 1174.48 522.109C1173.26 522.109 1172.27 523.101 1172.27 524.325Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M1174.48 558.596C1173.9 558.596 1173.33 558.362 1172.92 557.947C1172.5 557.531 1172.27 556.967 1172.27 556.38C1172.27 556.089 1172.32 555.801 1172.44 555.533C1172.55 555.264 1172.71 555.02 1172.92 554.815C1173.12 554.61 1173.37 554.447 1173.64 554.337C1173.9 554.226 1174.19 554.17 1174.48 554.171C1175.07 554.171 1175.63 554.403 1176.05 554.818C1176.46 555.232 1176.69 555.794 1176.69 556.38C1176.69 556.67 1176.64 556.958 1176.53 557.227C1176.42 557.496 1176.25 557.74 1176.05 557.946C1175.84 558.152 1175.6 558.315 1175.33 558.427C1175.06 558.538 1174.77 558.596 1174.48 558.596V558.596Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M1172.27 588.441C1172.27 589.665 1173.26 590.657 1174.48 590.657C1175.71 590.657 1176.7 589.665 1176.7 588.441C1176.7 587.217 1175.71 586.225 1174.48 586.225C1173.26 586.225 1172.27 587.217 1172.27 588.441Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M1172.27 620.503C1172.27 621.726 1173.26 622.718 1174.48 622.718C1175.71 622.718 1176.7 621.726 1176.7 620.503C1176.7 619.279 1175.71 618.287 1174.48 618.287C1173.26 618.287 1172.27 619.279 1172.27 620.503Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M1172.27 652.557C1172.27 653.781 1173.26 654.773 1174.48 654.773C1175.71 654.773 1176.7 653.781 1176.7 652.557C1176.7 651.333 1175.71 650.341 1174.48 650.341C1173.26 650.341 1172.27 651.333 1172.27 652.557Z"
          fill="#FF9B00"
        />
        <path
          opacity="0.62"
          d="M1172.27 684.612C1172.27 685.835 1173.26 686.828 1174.48 686.828C1175.71 686.828 1176.7 685.835 1176.7 684.612C1176.7 683.388 1175.71 682.396 1174.48 682.396C1173.26 682.396 1172.27 683.388 1172.27 684.612Z"
          fill="#80CE9D"
        />
        <path
          opacity="0.62"
          d="M1172.27 716.673C1172.27 717.897 1173.26 718.889 1174.48 718.889C1175.71 718.889 1176.7 717.897 1176.7 716.673C1176.7 715.449 1175.71 714.457 1174.48 714.457C1173.26 714.457 1172.27 715.449 1172.27 716.673Z"
          fill="#80CE9D"
        />
      </g>
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_244_1884"
        x1="80.6859"
        y1="984.752"
        x2="959.245"
        y2="-11.5933"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EB9900" />
        <stop offset="0.09" stopColor="#CC940E" />
        <stop offset="0.25" stopColor="#9D8B24" />
        <stop offset="0.41" stopColor="#768436" />
        <stop offset="0.57" stopColor="#577F44" />
        <stop offset="0.72" stopColor="#417B4E" />
        <stop offset="0.87" stopColor="#347954" />
        <stop offset="1" stopColor="#307856" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_244_1884"
        x1="-20.0016"
        y1="831.09"
        x2="629.454"
        y2="831.09"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1A2E2D" />
        <stop offset="0.74" stopColor="#302E2E" stopOpacity="0.5" />
        <stop offset="0.93" stopColor="#343333" stopOpacity="0.84" />
        <stop offset="1" stopColor="#363636" />
      </linearGradient>
      <clipPath id="clip0_244_1884">
        <rect width="1440" height="1024" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const MODAL_BACKGROUND = (
  <svg className="w-full" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 14.268V8.544c30.37.857 59.974 6.203 86.298 15.596l1.998.724c24.93 9.237 45.392 21.922 65.781 34.562 6.972 4.322 13.935 8.64 21.066 12.811 14.311 8.365 29.509 16.225 46.763 22.209 12.839 4.413 26.539 7.804 40.77 10.092 1.264.207 2.537.409 3.859.593 3.912.59 7.846 1.101 11.802 1.532 29.557 3.247 58.863 2.618 87.619-.516 53.363-5.8 104.931-20.184 153.122-34.485l8.554-2.538C551.534 62.03 575.486 54.92 600 48.668v5.97c-23.405 6.045-46.368 12.892-69.304 19.731-24.685 7.361-49.338 14.712-74.476 21.044-31.671 7.979-66.188 14.497-101.129 17.388-35.579 2.969-71.611 2.126-105.529-4.749a213.496 213.496 0 0 1-3.474-.724 263.426 263.426 0 0 1-17.37-4.346c-32.348-9.332-57.542-24.92-82.404-40.302a3565.952 3565.952 0 0 0-6.064-3.746C121.414 47.328 101.844 36.5 79.283 28.456c-11.02-3.96-22.74-7.131-34.932-9.45C29.943 16.293 15.043 14.702 0 14.267Z"
      fill="#FF9B00"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 81.344v-1.486l.69.283c23.692 9.765 48.254 19.047 74.633 25.201 56.984 13.286 117.496 11.012 172.1 2.423a633.05 633.05 0 0 0 16.445-2.805c28.02-5.227 55.306-11.878 81.585-19.888 36.617-11.057 72.317-24.19 106.851-36.894l.032-.012c5.941-2.184 11.907-4.373 17.898-6.565 39.201-14.361 79.73-28.65 122.076-39.657C594.695 1.324 597.262.672 600 0v1.319a574.621 574.621 0 0 0-6.896 1.747c-44.603 11.597-87.188 26.86-128.425 41.996l-11.301 4.179-.546.2c-34.413 12.652-69.978 25.727-106.481 36.753-25.374 7.73-51.681 14.203-78.678 19.363a668.045 668.045 0 0 1-16.78 2.936c-55.731 9.031-117.802 11.645-176.258-1.987-26.169-6.1-50.502-15.239-73.946-24.878L0 81.344Z"
      fill="url(#a)"
    />
    <defs>
      <linearGradient
        id="a"
        x1="-1.51"
        y1="62.587"
        x2="972"
        y2="62.587"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1A2E2D" />
        <stop offset=".74" stopColor="#302E2E" stopOpacity=".5" />
        <stop offset=".93" stopColor="#343333" stopOpacity=".84" />
        <stop offset="1" stopColor="#363636" />
      </linearGradient>
    </defs>
  </svg>
);

export const MODAL_BACKGROUND_REDESIGN = (
  <svg width="100%" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 4.93095V0.144531C30.3703 0.861497 59.9742 5.33161 86.2983 13.1862L88.2958 13.7918C113.226 21.5157 133.688 32.123 154.077 42.6927C161.049 46.3069 168.012 49.9168 175.143 53.4055C189.454 60.3999 204.652 66.9723 221.906 71.9762C234.745 75.6668 248.445 78.5025 262.676 80.4151C263.94 80.5889 265.213 80.7577 266.535 80.9116C270.447 81.4047 274.381 81.8316 278.337 82.1923C307.894 84.9077 337.2 84.3816 365.956 81.7605C419.319 76.9106 470.887 64.8825 519.078 52.924C521.929 52.2177 524.78 51.51 527.632 50.8021C551.534 44.8695 575.486 38.9244 600 33.6965V38.6881C576.595 43.7435 553.632 49.4693 530.696 55.1882C506.011 61.3432 481.358 67.4903 456.22 72.7854C424.549 79.4571 390.032 84.9078 355.091 87.3253C319.512 89.8073 283.48 89.1024 249.562 83.354C248.394 83.1604 247.246 82.9569 246.088 82.7484C240.183 81.6879 234.386 80.4751 228.718 79.1146C196.37 71.3104 171.176 58.276 146.314 45.4135C144.292 44.3672 142.271 43.322 140.25 42.2809C121.414 32.5761 101.844 23.5215 79.283 16.7951C68.2636 13.4836 56.5432 10.832 44.351 8.8923C29.9427 6.62475 15.0431 5.29443 0 4.93095Z"
      fill="#FF9B00"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 68.0203V66.7779L0.689409 67.0148C24.3818 75.1804 48.9443 82.9416 75.3233 88.0875C132.307 99.1979 192.819 97.2963 247.423 90.114C252.968 89.3853 258.45 88.6032 263.868 87.768C291.888 83.3977 319.174 77.8356 345.453 71.1375C382.07 61.8917 417.77 50.91 452.304 40.2868L452.336 40.277C458.277 38.4502 464.243 36.6201 470.234 34.7867C509.435 22.7779 549.964 10.8291 592.31 1.62534C594.695 1.10652 597.262 0.562113 600 0V1.1028C597.558 1.60683 595.256 2.09572 593.104 2.56362C548.501 12.2615 505.916 25.024 464.679 37.6816L453.378 41.1754L452.832 41.3434C418.419 51.9225 382.854 62.856 346.351 72.0758C320.977 78.5392 294.67 83.9529 267.673 88.2671C262.16 89.1356 256.566 89.9542 250.893 90.7229C195.162 98.2745 133.091 100.461 74.6349 89.0608C48.4662 83.9598 24.1332 76.3183 0.689409 68.2576L0 68.0203Z"
      fill="url(#paint0_linear_10651_21894)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_10651_21894"
        x1="-1.50956"
        y1="52.3357"
        x2="972"
        y2="52.3357"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1A2E2D" />
        <stop offset="0.74" stopColor="#302E2E" stopOpacity="0.5" />
        <stop offset="0.93" stopColor="#343333" stopOpacity="0.84" />
        <stop offset="1" stopColor="#363636" />
      </linearGradient>
    </defs>
  </svg>
);

export const DOWNLOAD_FOOTER_BACKGROUND = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 1512 222"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid meet"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 11.8255V0C85.0369 1.77132 167.928 12.8153 241.636 32.2212L247.229 33.7174C317.034 52.8003 374.327 79.007 431.416 105.121C450.938 114.05 470.435 122.969 490.401 131.588C530.471 148.869 573.026 165.107 621.336 177.469C657.288 186.588 695.647 193.594 735.492 198.319C739.032 198.748 742.598 199.165 746.3 199.546C757.252 200.764 768.266 201.819 779.344 202.71C862.104 209.419 944.161 208.119 1024.68 201.643C1174.09 189.661 1318.48 159.944 1453.42 130.398C1461.4 128.654 1469.38 126.905 1477.37 125.157C1488.91 122.63 1500.45 120.102 1512 117.583V130.266C1503.31 132.172 1494.63 134.083 1485.95 135.993C1416.83 151.199 1347.8 166.387 1277.42 179.469C1188.74 195.952 1092.09 209.419 994.255 215.391C894.635 221.524 793.746 219.782 698.773 205.58C695.504 205.102 692.289 204.599 689.046 204.084C672.513 201.464 656.281 198.467 640.412 195.106C549.835 175.825 479.293 143.622 409.68 111.843C404.017 109.258 398.361 106.676 392.7 104.103C339.959 80.1264 285.164 57.7559 221.993 41.1375C191.139 32.9558 158.322 26.4049 124.183 21.6125C83.8398 16.0102 42.1208 12.7235 0 11.8255Z"
      fill="#FF9B00"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 150.402V147.332L1.93109 147.918C68.2697 168.092 137.045 187.267 210.906 199.981C370.461 227.43 539.895 222.732 692.785 204.987C708.312 203.187 723.66 201.255 738.831 199.191C817.286 188.394 893.688 174.652 967.268 158.103C1069.8 135.26 1169.76 108.128 1266.45 81.8823L1266.54 81.8585C1283.18 77.3453 1299.88 72.8238 1316.66 68.294C1380.43 51.0568 1445.45 33.8695 1512 18.0332V20.9061C1440.1 38.0726 1369.93 56.8055 1301.1 75.4463L1269.46 84.0782L1267.93 84.4928C1171.58 110.63 1071.99 137.643 969.784 160.422C898.737 176.39 825.078 189.766 749.486 200.424C734.048 202.57 718.387 204.593 702.503 206.492C546.454 225.149 372.657 230.55 208.979 202.385C135.706 189.783 67.5737 170.903 1.93109 150.988L0 150.402Z"
      fill="url(#paint0_linear_7110_119756)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_7110_119756"
        x1="-3.80409"
        y1="128.082"
        x2="2449.44"
        y2="128.082"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1A2E2D" />
        <stop offset="0.74" stopColor="#302E2E" stopOpacity="0.5" />
        <stop offset="0.93" stopColor="#343333" stopOpacity="0.84" />
        <stop offset="1" stopColor="#363636" />
      </linearGradient>
    </defs>
  </svg>
);
export const DOWNLOAD_BACKGROUND = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 1512 551"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid meet"
  >
    <rect y="70" width="1512" height="481" fill="white" />
    <g opacity="0.62">
      <path
        opacity="0.62"
        d="M319.143 81.5955C322.128 81.5955 324.547 79.0078 324.547 75.8157C324.547 72.6237 322.128 70.0359 319.143 70.0359C316.159 70.0359 313.74 72.6237 313.74 75.8157C313.74 79.0078 316.159 81.5955 319.143 81.5955Z"
        fill="#80CE9D"
      />
      <path
        opacity="0.62"
        d="M402.709 75.7796C402.709 76.5377 402.569 77.2886 402.297 77.9888C402.025 78.689 401.627 79.3249 401.125 79.8602C400.623 80.3954 400.027 80.8192 399.372 81.1076C398.716 81.3961 398.014 81.5435 397.305 81.5411C395.877 81.5411 394.507 80.9341 393.497 79.8536C392.486 78.7731 391.919 77.3077 391.919 75.7796C391.917 75.0214 392.054 74.2702 392.324 73.5691C392.594 72.868 392.99 72.2306 393.491 71.6937C393.991 71.1568 394.586 70.7307 395.24 70.4401C395.895 70.1494 396.597 70 397.305 70C398.738 70 400.113 70.6089 401.126 71.6928C402.14 72.7767 402.709 74.2467 402.709 75.7796Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M475.484 81.5955C478.468 81.5955 480.887 79.0079 480.887 75.8158C480.887 72.6237 478.468 70.036 475.484 70.036C472.5 70.036 470.08 72.6237 470.08 75.8158C470.08 79.0079 472.5 81.5955 475.484 81.5955Z"
        fill="#80CE9D"
      />
      <path
        opacity="0.62"
        d="M1090.58 536.048C1093.56 536.048 1095.98 533.46 1095.98 530.268C1095.98 527.076 1093.56 524.488 1090.58 524.488C1087.59 524.488 1085.17 527.076 1085.17 530.268C1085.17 533.46 1087.59 536.048 1090.58 536.048Z"
        fill="#80CE9D"
      />
      <path
        opacity="0.62"
        d="M1016.29 530.25C1016.29 531.009 1016.15 531.761 1015.88 532.462C1015.6 533.163 1015.21 533.8 1014.7 534.337C1014.2 534.873 1013.61 535.3 1012.95 535.59C1012.3 535.88 1011.59 536.03 1010.88 536.03C1010.17 536.03 1009.47 535.88 1008.82 535.59C1008.16 535.3 1007.56 534.873 1007.06 534.337C1006.56 533.8 1006.16 533.163 1005.89 532.462C1005.62 531.761 1005.48 531.009 1005.48 530.25C1005.48 529.492 1005.62 528.741 1005.89 528.041C1006.16 527.34 1006.56 526.704 1007.06 526.169C1007.57 525.634 1008.16 525.21 1008.82 524.922C1009.47 524.633 1010.17 524.486 1010.88 524.488C1012.31 524.488 1013.69 525.094 1014.7 526.174C1015.71 527.254 1016.28 528.72 1016.29 530.25Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M1341.37 458.308C1341.37 459.841 1340.8 461.311 1339.78 462.395C1338.77 463.479 1337.4 464.087 1335.96 464.087C1334.53 464.087 1333.16 463.479 1332.14 462.395C1331.13 461.311 1330.56 459.841 1330.56 458.308C1330.56 456.775 1331.13 455.304 1332.14 454.22C1333.16 453.137 1334.53 452.528 1335.96 452.528C1337.4 452.528 1338.77 453.137 1339.78 454.22C1340.8 455.304 1341.37 456.775 1341.37 458.308Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M37.9967 498.401C37.9967 495.411 35.414 492.987 32.2282 492.987C29.0423 492.987 26.4597 495.411 26.4597 498.401C26.4597 501.391 29.0423 503.815 32.2282 503.815C35.414 503.815 37.9967 501.391 37.9967 498.401Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M37.9965 420.068C37.9965 417.078 35.4139 414.654 32.228 414.654C29.0421 414.654 26.4595 417.078 26.4595 420.068C26.4595 423.058 29.0421 425.482 32.228 425.482C35.4139 425.482 37.9965 423.058 37.9965 420.068Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M94.095 498.401C94.095 495.411 91.5123 492.987 88.3265 492.987C85.1406 492.987 82.558 495.411 82.558 498.401C82.558 501.391 85.1406 503.815 88.3265 503.815C91.5123 503.815 94.095 501.391 94.095 498.401Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M94.095 420.067C94.095 417.077 91.5123 414.653 88.3265 414.653C85.1406 414.653 82.558 417.077 82.558 420.067C82.558 423.057 85.1406 425.481 88.3265 425.481C91.5123 425.481 94.095 423.057 94.095 420.067Z"
        fill="#80CE9D"
      />
      <path
        opacity="0.62"
        d="M150.193 498.401C150.193 495.411 147.611 492.987 144.425 492.987C141.239 492.987 138.656 495.411 138.656 498.401C138.656 501.391 141.239 503.815 144.425 503.815C147.611 503.815 150.193 501.391 150.193 498.401Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M150.193 420.067C150.193 417.077 147.611 414.653 144.425 414.653C141.239 414.653 138.656 417.077 138.656 420.067C138.656 423.057 141.239 425.481 144.425 425.481C147.611 425.481 150.193 423.057 150.193 420.067Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M206.275 498.401C206.275 495.411 203.692 492.987 200.506 492.987C197.321 492.987 194.738 495.411 194.738 498.401C194.738 501.391 197.321 503.815 200.506 503.815C203.692 503.815 206.275 501.391 206.275 498.401Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M206.275 420.068C206.275 417.078 203.692 414.654 200.506 414.654C197.321 414.654 194.738 417.078 194.738 420.068C194.738 423.058 197.321 425.482 200.506 425.482C203.692 425.482 206.275 423.058 206.275 420.068Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M262.373 498.401C262.373 495.411 259.79 492.987 256.604 492.987C253.419 492.987 250.836 495.411 250.836 498.401C250.836 501.391 253.419 503.815 256.604 503.815C259.79 503.815 262.373 501.391 262.373 498.401Z"
        fill="#80CE9D"
      />
      <path
        opacity="0.62"
        d="M262.373 420.067C262.373 417.077 259.79 414.653 256.604 414.653C253.418 414.653 250.836 417.077 250.836 420.067C250.836 423.057 253.418 425.481 256.604 425.481C259.79 425.481 262.373 423.057 262.373 420.067Z"
        fill="#80CE9D"
      />
      <path
        opacity="0.62"
        d="M415.25 363.622C415.252 364.38 415.114 365.132 414.844 365.833C414.575 366.534 414.178 367.171 413.678 367.708C413.178 368.245 412.583 368.671 411.928 368.962C411.274 369.253 410.572 369.402 409.863 369.402C408.43 369.402 407.056 368.793 406.043 367.709C405.029 366.625 404.46 365.155 404.46 363.622C404.46 362.089 405.029 360.619 406.043 359.535C407.056 358.451 408.43 357.843 409.863 357.843C410.572 357.843 411.274 357.992 411.928 358.283C412.583 358.573 413.178 358.999 413.678 359.536C414.178 360.073 414.575 360.711 414.844 361.412C415.114 362.113 415.252 362.864 415.25 363.622Z"
        fill="#80CE9D"
      />
      <path
        opacity="0.62"
        d="M855.903 11.5596C858.887 11.5596 861.306 8.97191 861.306 5.77981C861.306 2.58771 858.887 0 855.903 0C852.918 0 850.499 2.58771 850.499 5.77981C850.499 8.97191 852.918 11.5596 855.903 11.5596Z"
        fill="#80CE9D"
      />
      <path
        opacity="0.62"
        d="M934.065 11.5596C937.049 11.5596 939.468 8.97191 939.468 5.77981C939.468 2.58771 937.049 0 934.065 0C931.08 0 928.661 2.58771 928.661 5.77981C928.661 8.97191 931.08 11.5596 934.065 11.5596Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M1012.23 11.5596C1015.21 11.5596 1017.63 8.97191 1017.63 5.77981C1017.63 2.58771 1015.21 0 1012.23 0C1009.24 0 1006.83 2.58771 1006.83 5.77981C1006.83 8.97191 1009.24 11.5596 1012.23 11.5596Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M1095.79 5.77971C1095.79 7.3126 1095.22 8.78307 1094.21 9.86699C1093.2 10.9509 1091.82 11.5599 1090.39 11.5599C1089.68 11.5599 1088.98 11.41 1088.32 11.1193C1087.67 10.8286 1087.08 10.4026 1086.57 9.86567C1086.07 9.32873 1085.68 8.69139 1085.41 7.99025C1085.14 7.28912 1085 6.53786 1085 5.77971C1085 4.24993 1085.57 2.78288 1086.58 1.69947C1087.59 0.616068 1088.96 0.00478054 1090.39 0C1091.82 0 1093.2 0.608936 1094.21 1.69286C1095.22 2.77678 1095.79 4.24681 1095.79 5.77971Z"
        fill="#80CE9D"
      />
      <path
        opacity="0.62"
        d="M1168.57 11.5596C1171.55 11.5596 1173.97 8.97191 1173.97 5.77981C1173.97 2.58771 1171.55 0 1168.57 0C1165.58 0 1163.17 2.58771 1163.17 5.77981C1163.17 8.97191 1165.58 11.5596 1168.57 11.5596Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M1246.75 11.5596C1249.73 11.5596 1252.15 8.97191 1252.15 5.77981C1252.15 2.58771 1249.73 0 1246.75 0C1243.76 0 1241.35 2.58771 1241.35 5.77981C1241.35 8.97191 1243.76 11.5596 1246.75 11.5596Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M1324.91 11.5596C1327.89 11.5596 1330.31 8.97191 1330.31 5.77981C1330.31 2.58771 1327.89 0 1324.91 0C1321.93 0 1319.51 2.58771 1319.51 5.77981C1319.51 8.97191 1321.93 11.5596 1324.91 11.5596Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M1403.07 11.5596C1406.06 11.5596 1408.48 8.97191 1408.48 5.77981C1408.48 2.58771 1406.06 0 1403.07 0C1400.09 0 1397.67 2.58771 1397.67 5.77981C1397.67 8.97191 1400.09 11.5596 1403.07 11.5596Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M1481.25 11.5596C1484.24 11.5596 1486.66 8.97191 1486.66 5.77981C1486.66 2.58771 1484.24 0 1481.25 0C1478.27 0 1475.85 2.58771 1475.85 5.77981C1475.85 8.97191 1478.27 11.5596 1481.25 11.5596Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M855.903 67.7677C858.887 67.7677 861.306 65.18 861.306 61.9879C861.306 58.7958 858.887 56.2081 855.903 56.2081C852.919 56.2081 850.499 58.7958 850.499 61.9879C850.499 65.18 852.919 67.7677 855.903 67.7677Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M934.065 67.7677C937.049 67.7677 939.468 65.18 939.468 61.9879C939.468 58.7958 937.049 56.2081 934.065 56.2081C931.08 56.2081 928.661 58.7958 928.661 61.9879C928.661 65.18 931.08 67.7677 934.065 67.7677Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M1012.23 67.7677C1015.21 67.7677 1017.63 65.18 1017.63 61.9879C1017.63 58.7958 1015.21 56.2081 1012.23 56.2081C1009.24 56.2081 1006.83 58.7958 1006.83 61.9879C1006.83 65.18 1009.24 67.7677 1012.23 67.7677Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M1095.79 61.9887C1095.79 63.5216 1095.22 64.9917 1094.21 66.0756C1093.2 67.1595 1091.82 67.7684 1090.39 67.7684C1089.68 67.7684 1088.98 67.619 1088.32 67.3284C1087.67 67.0377 1087.08 66.6116 1086.57 66.0747C1086.07 65.5378 1085.68 64.9004 1085.41 64.1993C1085.14 63.4982 1085 62.7469 1085 61.9887C1085 61.2306 1085.14 60.4793 1085.41 59.7782C1085.68 59.0771 1086.07 58.4397 1086.57 57.9028C1087.08 57.3658 1087.67 56.9398 1088.32 56.6491C1088.98 56.3584 1089.68 56.209 1090.39 56.209C1091.82 56.209 1093.2 56.818 1094.21 57.9019C1095.22 58.9858 1095.79 60.4558 1095.79 61.9887Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M1168.57 67.7677C1171.55 67.7677 1173.97 65.18 1173.97 61.9879C1173.97 58.7958 1171.55 56.2081 1168.57 56.2081C1165.58 56.2081 1163.17 58.7958 1163.17 61.9879C1163.17 65.18 1165.58 67.7677 1168.57 67.7677Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M1246.75 67.7677C1249.73 67.7677 1252.15 65.18 1252.15 61.9879C1252.15 58.7958 1249.73 56.2081 1246.75 56.2081C1243.76 56.2081 1241.35 58.7958 1241.35 61.9879C1241.35 65.18 1243.76 67.7677 1246.75 67.7677Z"
        fill="#80CE9D"
      />
      <path
        opacity="0.62"
        d="M1324.91 67.7677C1327.89 67.7677 1330.31 65.18 1330.31 61.9879C1330.31 58.7958 1327.89 56.2081 1324.91 56.2081C1321.93 56.2081 1319.51 58.7958 1319.51 61.9879C1319.51 65.18 1321.93 67.7677 1324.91 67.7677Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M1403.07 67.7677C1406.06 67.7677 1408.48 65.18 1408.48 61.9879C1408.48 58.7958 1406.06 56.2081 1403.07 56.2081C1400.09 56.2081 1397.67 58.7958 1397.67 61.9879C1397.67 65.18 1400.09 67.7677 1403.07 67.7677Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M1481.25 67.7677C1484.24 67.7677 1486.66 65.18 1486.66 61.9879C1486.66 58.7958 1484.24 56.2081 1481.25 56.2081C1478.27 56.2081 1475.85 58.7958 1475.85 61.9879C1475.85 65.18 1478.27 67.7677 1481.25 67.7677Z"
        fill="#80CE9D"
      />
      <path
        opacity="0.62"
        d="M855.903 123.977C858.887 123.977 861.306 121.389 861.306 118.197C861.306 115.005 858.887 112.417 855.903 112.417C852.919 112.417 850.499 115.005 850.499 118.197C850.499 121.389 852.919 123.977 855.903 123.977Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M934.065 123.977C937.049 123.977 939.468 121.389 939.468 118.197C939.468 115.005 937.049 112.417 934.065 112.417C931.08 112.417 928.661 115.005 928.661 118.197C928.661 121.389 931.08 123.977 934.065 123.977Z"
        fill="#80CE9D"
      />
      <path
        opacity="0.62"
        d="M1012.23 123.977C1015.21 123.977 1017.63 121.389 1017.63 118.197C1017.63 115.005 1015.21 112.417 1012.23 112.417C1009.24 112.417 1006.83 115.005 1006.83 118.197C1006.83 121.389 1009.24 123.977 1012.23 123.977Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M1095.79 118.196C1095.79 119.729 1095.22 121.2 1094.21 122.284C1093.2 123.368 1091.82 123.976 1090.39 123.976C1088.96 123.972 1087.59 123.36 1086.58 122.277C1085.57 121.194 1085 119.726 1085 118.196C1085 117.438 1085.14 116.687 1085.41 115.986C1085.68 115.285 1086.07 114.648 1086.57 114.111C1087.08 113.574 1087.67 113.148 1088.32 112.857C1088.98 112.567 1089.68 112.417 1090.39 112.417C1091.82 112.417 1093.2 113.026 1094.21 114.11C1095.22 115.193 1095.79 116.664 1095.79 118.196Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M1168.57 123.977C1171.55 123.977 1173.97 121.389 1173.97 118.197C1173.97 115.005 1171.55 112.417 1168.57 112.417C1165.58 112.417 1163.17 115.005 1163.17 118.197C1163.17 121.389 1165.58 123.977 1168.57 123.977Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M1246.75 123.977C1249.73 123.977 1252.15 121.389 1252.15 118.197C1252.15 115.005 1249.73 112.417 1246.75 112.417C1243.76 112.417 1241.35 115.005 1241.35 118.197C1241.35 121.389 1243.76 123.977 1246.75 123.977Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M1324.91 123.977C1327.89 123.977 1330.31 121.389 1330.31 118.197C1330.31 115.005 1327.89 112.417 1324.91 112.417C1321.93 112.417 1319.51 115.005 1319.51 118.197C1319.51 121.389 1321.93 123.977 1324.91 123.977Z"
        fill="#80CE9D"
      />
      <path
        opacity="0.62"
        d="M1403.07 123.977C1406.06 123.977 1408.48 121.389 1408.48 118.197C1408.48 115.005 1406.06 112.417 1403.07 112.417C1400.09 112.417 1397.67 115.005 1397.67 118.197C1397.67 121.389 1400.09 123.977 1403.07 123.977Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M1481.25 123.977C1484.24 123.977 1486.66 121.389 1486.66 118.197C1486.66 115.005 1484.24 112.417 1481.25 112.417C1478.27 112.417 1475.85 115.005 1475.85 118.197C1475.85 121.389 1478.27 123.977 1481.25 123.977Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M855.903 180.167C858.887 180.167 861.306 177.579 861.306 174.387C861.306 171.195 858.887 168.607 855.903 168.607C852.919 168.607 850.499 171.195 850.499 174.387C850.499 177.579 852.919 180.167 855.903 180.167Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M934.065 180.167C937.049 180.167 939.468 177.579 939.468 174.387C939.468 171.195 937.049 168.607 934.065 168.607C931.08 168.607 928.661 171.195 928.661 174.387C928.661 177.579 931.08 180.167 934.065 180.167Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M1012.23 180.167C1015.21 180.167 1017.63 177.579 1017.63 174.387C1017.63 171.195 1015.21 168.607 1012.23 168.607C1009.24 168.607 1006.83 171.195 1006.83 174.387C1006.83 177.579 1009.24 180.167 1012.23 180.167Z"
        fill="#80CE9D"
      />
      <path
        opacity="0.62"
        d="M1095.79 174.351C1095.79 175.109 1095.65 175.86 1095.38 176.56C1095.11 177.26 1094.71 177.896 1094.21 178.431C1093.71 178.967 1093.11 179.39 1092.46 179.679C1091.8 179.967 1091.1 180.115 1090.39 180.112C1088.96 180.112 1087.59 179.505 1086.58 178.425C1085.57 177.344 1085 175.879 1085 174.351C1085 173.593 1085.14 172.841 1085.41 172.14C1085.68 171.439 1086.07 170.802 1086.57 170.265C1087.08 169.728 1087.67 169.302 1088.32 169.011C1088.98 168.721 1089.68 168.571 1090.39 168.571C1091.82 168.571 1093.2 169.18 1094.21 170.264C1095.22 171.348 1095.79 172.818 1095.79 174.351Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M1168.57 180.167C1171.55 180.167 1173.97 177.579 1173.97 174.387C1173.97 171.195 1171.55 168.607 1168.57 168.607C1165.58 168.607 1163.17 171.195 1163.17 174.387C1163.17 177.579 1165.58 180.167 1168.57 180.167Z"
        fill="#80CE9D"
      />
      <path
        opacity="0.62"
        d="M1246.75 180.167C1249.73 180.167 1252.15 177.579 1252.15 174.387C1252.15 171.195 1249.73 168.607 1246.75 168.607C1243.76 168.607 1241.35 171.195 1241.35 174.387C1241.35 177.579 1243.76 180.167 1246.75 180.167Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M1324.91 180.167C1327.89 180.167 1330.31 177.579 1330.31 174.387C1330.31 171.195 1327.89 168.607 1324.91 168.607C1321.93 168.607 1319.51 171.195 1319.51 174.387C1319.51 177.579 1321.93 180.167 1324.91 180.167Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M1403.07 180.167C1406.06 180.167 1408.48 177.579 1408.48 174.387C1408.48 171.195 1406.06 168.607 1403.07 168.607C1400.09 168.607 1397.67 171.195 1397.67 174.387C1397.67 177.579 1400.09 180.167 1403.07 180.167Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M1481.25 180.167C1484.24 180.167 1486.66 177.579 1486.66 174.387C1486.66 171.195 1484.24 168.607 1481.25 168.607C1478.27 168.607 1475.85 171.195 1475.85 174.387C1475.85 177.579 1478.27 180.167 1481.25 180.167Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M855.903 236.375C858.887 236.375 861.306 233.787 861.306 230.595C861.306 227.403 858.887 224.815 855.903 224.815C852.919 224.815 850.499 227.403 850.499 230.595C850.499 233.787 852.919 236.375 855.903 236.375Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M934.065 236.375C937.049 236.375 939.468 233.787 939.468 230.595C939.468 227.403 937.049 224.815 934.065 224.815C931.08 224.815 928.661 227.403 928.661 230.595C928.661 233.787 931.08 236.375 934.065 236.375Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M1012.23 236.375C1015.21 236.375 1017.63 233.787 1017.63 230.595C1017.63 227.403 1015.21 224.815 1012.23 224.815C1009.24 224.815 1006.83 227.403 1006.83 230.595C1006.83 233.787 1009.24 236.375 1012.23 236.375Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M1095.79 230.595C1095.79 232.128 1095.22 233.599 1094.21 234.683C1093.2 235.766 1091.82 236.375 1090.39 236.375C1089.68 236.375 1088.98 236.226 1088.32 235.935C1087.67 235.644 1087.08 235.218 1086.57 234.681C1086.07 234.144 1085.68 233.507 1085.41 232.806C1085.14 232.105 1085 231.353 1085 230.595C1085 229.067 1085.57 227.602 1086.58 226.521C1087.59 225.441 1088.96 224.834 1090.39 224.834C1091.1 224.831 1091.8 224.979 1092.46 225.267C1093.11 225.556 1093.71 225.98 1094.21 226.515C1094.71 227.05 1095.11 227.686 1095.38 228.386C1095.65 229.087 1095.79 229.837 1095.79 230.595Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M1168.57 236.375C1171.55 236.375 1173.97 233.787 1173.97 230.595C1173.97 227.403 1171.55 224.815 1168.57 224.815C1165.58 224.815 1163.17 227.403 1163.17 230.595C1163.17 233.787 1165.58 236.375 1168.57 236.375Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M1246.75 236.375C1249.73 236.375 1252.15 233.787 1252.15 230.595C1252.15 227.403 1249.73 224.815 1246.75 224.815C1243.76 224.815 1241.35 227.403 1241.35 230.595C1241.35 233.787 1243.76 236.375 1246.75 236.375Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M1324.91 236.375C1327.89 236.375 1330.31 233.787 1330.31 230.595C1330.31 227.403 1327.89 224.815 1324.91 224.815C1321.93 224.815 1319.51 227.403 1319.51 230.595C1319.51 233.787 1321.93 236.375 1324.91 236.375Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M1403.07 236.375C1406.06 236.375 1408.48 233.787 1408.48 230.595C1408.48 227.403 1406.06 224.815 1403.07 224.815C1400.09 224.815 1397.67 227.403 1397.67 230.595C1397.67 233.787 1400.09 236.375 1403.07 236.375Z"
        fill="#80CE9D"
      />
      <path
        opacity="0.62"
        d="M1481.25 236.375C1484.24 236.375 1486.66 233.787 1486.66 230.595C1486.66 227.403 1484.24 224.815 1481.25 224.815C1478.27 224.815 1475.85 227.403 1475.85 230.595C1475.85 233.787 1478.27 236.375 1481.25 236.375Z"
        fill="#80CE9D"
      />
    </g>
    <path
      d="M679.89 379.135L684.552 454.766L791.065 336.62L633.075 319.613L679.89 379.135Z"
      stroke="#333333"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M678.801 379.549L791.065 336.62"
      stroke="#333333"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M0 272.626C234.36 444.953 567 431.697 672.84 384.354"
      stroke="black"
      strokeWidth="4"
      strokeDasharray="9 9"
    />
  </svg>
);

export const DOWNLOAD_LITLINGO_LOGO = (
  <svg width="200" height="34" viewBox="0 0 200 34" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_7110_119763)">
      <path d="M47.9656 7.34747H49.9092V24.0567H60.2075V25.7381H47.9656V7.34747Z" fill="#0D2928" />
      <path d="M67.6424 7.34747H69.586V25.7381H67.6424V7.34747Z" fill="#0D2928" />
      <path
        d="M83.3529 9.02882H76.8898V7.34747H91.7597V9.02882H85.2966V25.7381H83.3529V9.02882Z"
        fill="#0D2928"
      />
      <path d="M98.2497 7.34747H102.505V22.2695H111.727V25.7381H98.2497V7.34747Z" fill="#0D2928" />
      <path d="M118.32 7.34747H122.576V25.7381H118.32V7.34747Z" fill="#0D2928" />
      <path
        d="M148.008 7.34747V25.7381H144.514L135.345 14.5722V25.7381H131.142V7.34747H134.663L143.806 18.5133V7.34747H148.008Z"
        fill="#0D2928"
      />
      <path
        d="M168.999 16.2536H172.888V23.7155C171.89 24.4687 170.734 25.0471 169.42 25.4489C168.106 25.8524 166.783 26.0525 165.453 26.0525C163.543 26.0525 161.828 25.6456 160.303 24.8302C158.78 24.0164 157.585 22.8865 156.717 21.4406C155.849 19.9963 155.417 18.362 155.417 16.5411C155.417 14.7202 155.851 13.0859 156.717 11.6417C157.585 10.1974 158.788 9.06752 160.33 8.25207C161.872 7.43829 163.606 7.02972 165.532 7.02972C167.143 7.02972 168.606 7.3021 169.919 7.8435C171.232 8.38657 172.337 9.17513 173.23 10.2075L170.497 12.7295C169.184 11.3458 167.599 10.6547 165.743 10.6547C164.569 10.6547 163.526 10.9002 162.617 11.3911C161.706 11.8821 160.996 12.5731 160.488 13.4659C159.981 14.3587 159.727 15.3844 159.727 16.5394C159.727 17.6777 159.981 18.6933 160.488 19.5877C160.996 20.4805 161.701 21.1766 162.603 21.676C163.505 22.1753 164.535 22.4242 165.69 22.4242C166.916 22.4242 168.019 22.1619 169.001 21.6356V16.2536H168.999Z"
        fill="#0D2928"
      />
      <path
        d="M184.775 24.8184C183.242 23.9946 182.043 22.8613 181.176 21.4171C180.308 19.9728 179.876 18.3469 179.876 16.5428C179.876 14.7387 180.31 13.1146 181.176 11.6686C182.043 10.2243 183.242 9.08941 184.775 8.26554C186.307 7.44168 188.029 7.03143 189.937 7.03143C191.845 7.03143 193.562 7.44336 195.087 8.26554C196.61 9.08941 197.811 10.2226 198.687 11.6686C199.563 13.1129 200 14.7387 200 16.5428C200 18.3469 199.561 19.9711 198.687 21.4171C197.811 22.8613 196.612 23.9963 195.087 24.8184C193.564 25.6423 191.847 26.0525 189.937 26.0525C188.029 26.0525 186.307 25.6423 184.775 24.8184ZM192.879 21.6794C193.755 21.18 194.443 20.4839 194.942 19.5911C195.442 18.6983 195.691 17.6828 195.691 16.5428C195.691 15.4046 195.442 14.389 194.942 13.4945C194.443 12.6017 193.755 11.9057 192.879 11.4063C192.003 10.9069 191.023 10.6581 189.937 10.6581C188.851 10.6581 187.871 10.9069 186.995 11.4063C186.119 11.9057 185.431 12.6017 184.932 13.4945C184.432 14.3873 184.184 15.4046 184.184 16.5428C184.184 17.6811 184.432 18.6966 184.932 19.5911C185.431 20.4839 186.119 21.18 186.995 21.6794C187.871 22.1787 188.851 22.4276 189.937 22.4276C191.023 22.4276 192.003 22.1787 192.879 21.6794Z"
        fill="#0D2928"
      />
      <path d="M23.6566 9.42395V14.1368H20.3225L18.9471 14.9976V9.42395H23.6566Z" fill="#F8A01A" />
      <path
        d="M14.1973 4.71114V0H0V4.71114V33.0856H3.73092H14.1973V28.3728H4.70947V4.71114H14.1973Z"
        fill="#58A280"
      />
      <path
        d="M18.9068 0V4.71114H28.3661V28.3728H18.9068V33.0856H33.0755V30.3366V28.3728V4.71114V2.74901V0H18.9068Z"
        fill="#58A280"
      />
      <path d="M23.6566 18.8799V23.6616H9.41895V9.42395H14.2024V18.8799H23.6566Z" fill="#0D2928" />
    </g>
    <defs>
      <clipPath id="clip0_7110_119763">
        <rect width="200" height="33.0856" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const STOP_ICON = (
  <svg
    width="517"
    height="373"
    viewBox="0 0 517 373"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.5"
      d="M178.909 350.281C264.569 350.281 334.009 281.053 334.009 195.655C334.009 110.258 264.569 41.03 178.909 41.03C93.2498 41.03 23.8092 110.258 23.8092 195.655C23.8092 281.053 93.2498 350.281 178.909 350.281Z"
      fill="#8FE3BE"
    />
    <path
      d="M437.409 345.195C437.409 356.385 428.566 365.201 417.682 365.201H97.6178C86.7336 365.201 77.8901 356.045 77.8901 345.195V146.487C77.8901 135.297 86.7336 126.481 97.6178 126.481H417.682C428.566 126.481 437.409 135.636 437.409 146.487V345.195Z"
      fill="#333333"
    />
    <path
      d="M424.484 335.361C424.484 345.195 416.321 353.672 406.117 353.672H109.182C99.3183 353.672 90.8151 345.534 90.8151 335.361V156.321C90.8151 146.487 98.9782 138.01 109.182 138.01H406.457C416.321 138.01 424.824 146.148 424.824 156.321V335.361H424.484Z"
      fill="white"
    />
    <path
      d="M416.321 133.602H99.3183C92.5157 133.602 87.0736 139.027 87.0736 145.809V346.212C87.0736 352.994 92.5157 358.419 99.3183 358.419H416.321C423.124 358.419 428.566 352.994 428.566 346.212V145.809C428.566 139.027 423.124 133.602 416.321 133.602ZM416.321 145.809V346.212H99.3183V145.809H416.321Z"
      fill="white"
    />
    <path
      d="M56.802 363.166C60.2033 368.253 65.9855 371.305 72.4481 371.305H442.851C449.314 371.305 455.096 367.914 458.497 363.166H56.802Z"
      fill="#333333"
    />
    <mask
      id="mask0_10961_69059"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="56"
      y="363"
      width="403"
      height="9"
    >
      <path
        d="M56.802 363.166C60.2033 368.253 65.9855 371.305 72.4481 371.305H442.851C449.314 371.305 455.096 367.914 458.497 363.166H56.802Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_10961_69059)">
      <path
        d="M56.802 363.166C60.2033 368.253 65.9855 371.305 72.4481 371.305H442.851C449.314 371.305 455.096 367.914 458.497 363.166H56.802Z"
        fill="#333333"
      />
    </g>
    <mask
      id="mask1_10961_69059"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="56"
      y="363"
      width="403"
      height="9"
    >
      <path
        d="M56.802 363.166C60.2033 368.253 65.9855 371.305 72.4481 371.305H442.851C449.314 371.305 455.096 367.914 458.497 363.166H56.802Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask1_10961_69059)">
      <path d="M590.128 367.235H20.0677V434.715H590.128V367.235Z" fill="#333333" />
    </g>
    <path
      d="M158.161 338.752C155.44 338.752 153.399 336.717 153.399 334.005C153.399 331.292 155.44 329.257 158.161 329.257C160.882 329.257 162.923 331.292 162.923 334.005C162.583 336.717 160.542 338.752 158.161 338.752Z"
      stroke="#00E1B4"
      strokeWidth="0.6829"
      strokeMiterlimit="10"
    />
    <path
      d="M113.264 338.752C110.543 338.752 108.502 336.717 108.502 334.005C108.502 331.292 110.543 329.257 113.264 329.257C115.985 329.257 118.026 331.292 118.026 334.005C117.686 336.717 115.645 338.752 113.264 338.752Z"
      stroke="#00E1B4"
      strokeWidth="0.6829"
      strokeMiterlimit="10"
    />
    <path
      d="M153.399 334.005H117.345"
      stroke="#00E1B4"
      strokeWidth="0.6829"
      strokeMiterlimit="10"
    />
    <path
      d="M158.161 172.597C155.44 172.597 153.399 170.563 153.399 167.85C153.399 165.137 155.44 163.103 158.161 163.103C160.882 163.103 162.923 165.137 162.923 167.85C162.583 170.563 160.542 172.597 158.161 172.597Z"
      stroke="#00E1B4"
      strokeWidth="0.6829"
      strokeMiterlimit="10"
    />
    <path
      d="M113.264 172.597C110.543 172.597 108.502 170.563 108.502 167.85C108.502 165.137 110.543 163.103 113.264 163.103C115.985 163.103 118.026 165.137 118.026 167.85C117.686 170.563 115.645 172.597 113.264 172.597Z"
      stroke="#00E1B4"
      strokeWidth="0.6829"
      strokeMiterlimit="10"
    />
    <path d="M153.399 167.85H117.345" stroke="#00E1B4" strokeWidth="0.6829" strokeMiterlimit="10" />
    <path
      d="M158.161 190.908C155.44 190.908 153.399 188.874 153.399 186.161C153.399 183.448 155.44 181.414 158.161 181.414C160.882 181.414 162.923 183.448 162.923 186.161C162.923 188.874 160.542 190.908 158.161 190.908Z"
      stroke="#FF9B00"
      strokeWidth="0.6829"
      strokeMiterlimit="10"
    />
    <path
      d="M113.264 190.908C110.543 190.908 108.502 188.874 108.502 186.161C108.502 183.448 110.543 181.414 113.264 181.414C115.985 181.414 118.026 183.448 118.026 186.161C118.026 188.874 115.645 190.908 113.264 190.908Z"
      stroke="#FF9B00"
      strokeWidth="0.6829"
      strokeMiterlimit="10"
    />
    <path
      d="M153.399 186.161H117.345"
      stroke="#FF9B00"
      strokeWidth="0.6829"
      strokeMiterlimit="10"
    />
    <path
      d="M139.794 210.236C137.073 210.236 135.032 208.202 135.032 205.489C135.032 202.776 137.073 200.742 139.794 200.742C142.515 200.742 144.556 202.776 144.556 205.489C144.556 208.202 142.515 210.236 139.794 210.236Z"
      stroke="#00E1B4"
      strokeWidth="0.6829"
      strokeMiterlimit="10"
    />
    <path
      d="M113.264 210.236C110.543 210.236 108.502 208.202 108.502 205.489C108.502 202.776 110.543 200.742 113.264 200.742C115.985 200.742 118.026 202.776 118.026 205.489C118.026 208.202 115.645 210.236 113.264 210.236Z"
      stroke="#00E1B4"
      strokeWidth="0.6829"
      strokeMiterlimit="10"
    />
    <path
      d="M135.372 205.828H117.345"
      stroke="#00E1B4"
      strokeWidth="0.6829"
      strokeMiterlimit="10"
    />
    <path
      d="M15.3059 109.865L20.748 104.44C21.4283 103.762 21.4283 102.405 20.748 101.388C20.0677 100.71 18.7072 100.71 17.6868 101.388L12.2447 106.814L6.8026 101.388C6.12233 100.71 4.76181 100.71 3.74141 101.388C2.72102 102.066 3.06115 103.423 3.74141 104.44L9.18352 109.865L3.74141 115.291C3.06115 115.969 3.06115 117.325 3.74141 118.343C4.42168 119.36 5.7822 119.021 6.8026 118.343L12.2447 112.917L17.6868 118.343C18.3671 119.021 19.7276 119.021 20.748 118.343C21.4283 117.665 21.4283 116.308 20.748 115.291L15.3059 109.865Z"
      fill="#FF9B00"
    />
    <path
      d="M187.412 63.0709H182.991C182.311 63.0709 181.63 63.7491 181.63 64.4273C181.63 65.1055 182.311 65.7836 182.991 65.7836H187.412V70.1918C187.412 70.87 188.093 71.5482 188.773 71.5482C189.453 71.5482 190.134 70.87 190.134 70.1918V65.7836H194.555C195.236 65.7836 195.916 65.1055 195.916 64.4273C195.916 63.7491 195.236 63.0709 194.555 63.0709H190.134V58.6627C190.134 57.9845 189.453 57.3064 188.773 57.3064C188.093 57.3064 187.412 57.9845 187.412 58.6627V63.0709Z"
      fill="#45D09C"
    />
    <path
      d="M187.412 44.4209H182.991C182.311 44.4209 181.63 45.0991 181.63 45.7773C181.63 46.4555 182.311 47.1336 182.991 47.1336H187.412V51.5418C187.412 52.22 188.093 52.8982 188.773 52.8982C189.453 52.8982 190.134 52.22 190.134 51.5418V47.1336H194.555C195.236 47.1336 195.916 46.4555 195.916 45.7773C195.916 45.0991 195.236 44.4209 194.555 44.4209H190.134V40.0127C190.134 39.3346 189.453 38.6564 188.773 38.6564C188.093 38.6564 187.412 39.3346 187.412 40.0127V44.4209Z"
      fill="#45D09C"
    />
    <path
      d="M187.412 26.11H182.991C182.311 26.11 181.63 26.7882 181.63 27.4664C181.63 28.1446 182.311 28.8227 182.991 28.8227H187.412V33.2309C187.412 33.9091 188.093 34.5873 188.773 34.5873C189.453 34.5873 190.134 33.9091 190.134 33.2309V28.4836H194.555C195.236 28.4836 195.916 27.8055 195.916 27.1273C195.916 26.4491 195.236 25.7709 194.555 25.7709H190.134V21.3627C190.134 20.6846 189.453 20.0064 188.773 20.0064C188.093 20.0064 187.412 20.6846 187.412 21.3627V26.11Z"
      fill="#45D09C"
    />
    <path
      d="M187.412 7.46001H182.991C182.311 7.46001 181.63 8.13819 181.63 8.81637C181.63 9.49456 182.311 10.1727 182.991 10.1727H187.412V14.5809C187.412 15.2591 188.093 15.9373 188.773 15.9373C189.453 15.9373 190.134 15.2591 190.134 14.5809V10.1727H194.555C195.236 10.1727 195.916 9.49456 195.916 8.81637C195.916 8.13819 195.236 7.46001 194.555 7.46001H190.134V3.05183C190.134 2.37365 189.453 1.69547 188.773 1.69547C188.093 1.69547 187.412 2.37365 187.412 3.05183V7.46001Z"
      fill="#45D09C"
    />
    <path
      d="M205.78 63.0709H201.358C200.678 63.0709 199.997 63.7491 199.997 64.4273C199.997 65.1055 200.678 65.7836 201.358 65.7836H205.78V70.1918C205.78 70.87 206.46 71.5482 207.14 71.5482C207.82 71.5482 208.501 70.87 208.501 70.1918V65.7836H212.922C213.603 65.7836 214.283 65.1055 214.283 64.4273C214.283 63.7491 213.603 63.0709 212.922 63.0709H208.501V58.6627C208.501 57.9845 207.82 57.3064 207.14 57.3064C206.46 57.3064 205.78 57.9845 205.78 58.6627V63.0709Z"
      fill="#45D09C"
    />
    <path
      d="M205.78 44.4209H201.358C200.678 44.4209 199.997 45.0991 199.997 45.7773C199.997 46.4555 200.678 47.1336 201.358 47.1336H205.78V51.5418C205.78 52.22 206.46 52.8982 207.14 52.8982C207.82 52.8982 208.501 52.22 208.501 51.5418V47.1336H212.922C213.603 47.1336 214.283 46.4555 214.283 45.7773C214.283 45.0991 213.603 44.4209 212.922 44.4209H208.501V40.0127C208.501 39.3346 207.82 38.6564 207.14 38.6564C206.46 38.6564 205.78 39.3346 205.78 40.0127V44.4209Z"
      fill="#45D09C"
    />
    <path
      d="M205.78 26.11H201.358C200.678 26.11 199.997 26.7882 199.997 27.4664C199.997 28.1446 200.678 28.8227 201.358 28.8227H205.78V33.2309C205.78 33.9091 206.46 34.5873 207.14 34.5873C207.82 34.5873 208.501 33.9091 208.501 33.2309V28.4836H212.922C213.603 28.4836 214.283 27.8055 214.283 27.1273C214.283 26.4491 213.603 25.7709 212.922 25.7709H208.501V21.3627C208.501 20.6846 207.82 20.0064 207.14 20.0064C206.46 20.0064 205.78 20.6846 205.78 21.3627V26.11Z"
      fill="#45D09C"
    />
    <path
      d="M205.78 7.46001H201.358C200.678 7.46001 199.997 8.13819 199.997 8.81637C199.997 9.49456 200.678 10.1727 201.358 10.1727H205.78V14.5809C205.78 15.2591 206.46 15.9373 207.14 15.9373C207.82 15.9373 208.501 15.2591 208.501 14.5809V10.1727H212.922C213.603 10.1727 214.283 9.49456 214.283 8.81637C214.283 8.13819 213.603 7.46001 212.922 7.46001H208.501V3.05183C208.501 2.37365 207.82 1.69547 207.14 1.69547C206.46 1.69547 205.78 2.37365 205.78 3.05183V7.46001Z"
      fill="#45D09C"
    />
    <path
      d="M224.147 63.0709H219.725C219.045 63.0709 218.365 63.7491 218.365 64.4273C218.365 65.1055 219.045 65.7836 219.725 65.7836H224.147V70.1918C224.147 70.87 224.827 71.5482 225.507 71.5482C226.188 71.5482 226.868 70.87 226.868 70.1918V65.7836H231.29C231.97 65.7836 232.65 65.1055 232.65 64.4273C232.65 63.7491 231.97 63.0709 231.29 63.0709H226.868V58.6627C226.868 57.9845 226.188 57.3064 225.507 57.3064C224.827 57.3064 224.147 57.9845 224.147 58.6627V63.0709Z"
      fill="#45D09C"
    />
    <path
      d="M224.147 44.4209H219.725C219.045 44.4209 218.365 45.0991 218.365 45.7773C218.365 46.4555 219.045 47.1336 219.725 47.1336H224.147V51.5418C224.147 52.22 224.827 52.8982 225.507 52.8982C226.188 52.8982 226.868 52.22 226.868 51.5418V47.1336H231.29C231.97 47.1336 232.65 46.4555 232.65 45.7773C232.65 45.0991 231.97 44.4209 231.29 44.4209H226.868V40.0127C226.868 39.3346 226.188 38.6564 225.507 38.6564C224.827 38.6564 224.147 39.3346 224.147 40.0127V44.4209Z"
      fill="#45D09C"
    />
    <path
      d="M224.147 26.11H219.725C219.045 26.11 218.365 26.7882 218.365 27.4664C218.365 28.1446 219.045 28.8227 219.725 28.8227H224.147V33.2309C224.147 33.9091 224.827 34.5873 225.507 34.5873C226.188 34.5873 226.868 33.9091 226.868 33.2309V28.4836H231.29C231.97 28.4836 232.65 27.8055 232.65 27.1273C232.65 26.4491 231.97 25.7709 231.29 25.7709H226.868V21.3627C226.868 20.6846 226.188 20.0064 225.507 20.0064C224.827 20.0064 224.147 20.6846 224.147 21.3627V26.11Z"
      fill="#45D09C"
    />
    <path
      d="M224.147 7.46001H219.725C219.045 7.46001 218.365 8.13819 218.365 8.81637C218.365 9.49456 219.045 10.1727 219.725 10.1727H224.147V14.5809C224.147 15.2591 224.827 15.9373 225.507 15.9373C226.188 15.9373 226.868 15.2591 226.868 14.5809V10.1727H231.29C231.97 10.1727 232.65 9.49456 232.65 8.81637C232.65 8.13819 232.31 7.46001 231.29 7.46001H226.868V3.05183C226.868 2.37365 226.188 1.69547 225.507 1.69547C224.827 1.69547 224.147 2.37365 224.147 3.05183V7.46001Z"
      fill="#45D09C"
    />
    <path
      d="M139.794 95.6236H147.277C148.297 95.6236 149.318 94.6064 149.318 93.5891C149.318 92.5718 148.297 91.5546 147.277 91.5546H139.794V84.0946C139.794 83.0773 138.774 82.06 137.753 82.06C136.733 82.06 135.712 83.0773 135.712 84.0946V91.5546H128.23C127.209 91.5546 126.189 92.5718 126.189 93.5891C126.189 94.6064 127.209 95.6236 128.23 95.6236H135.712V103.084C135.712 104.101 136.733 105.118 137.753 105.118C138.774 105.118 139.794 104.101 139.794 103.084V95.6236Z"
      fill="#45D09C"
    />
    <path
      d="M475.844 271.273L481.286 265.847C481.966 265.169 481.966 263.813 481.286 262.795C480.606 262.117 479.245 262.117 478.225 262.795L472.783 268.221L467.341 262.795C466.661 262.117 465.3 262.117 464.28 262.795C463.599 263.474 463.599 264.83 464.28 265.847L469.722 271.273L464.28 276.698C463.599 277.376 463.599 278.733 464.28 279.75C464.96 280.428 466.32 280.428 467.341 279.75L472.783 274.325L478.225 279.75C478.905 280.428 480.266 280.428 481.286 279.75C481.966 279.072 481.966 277.715 481.286 276.698L475.844 271.273Z"
      fill="#45D09C"
    />
    <path
      d="M28.2308 259.065C22.4486 259.065 17.6868 254.318 17.6868 248.554C17.6868 242.789 22.4486 238.042 28.2308 238.042C34.0131 238.042 38.7749 242.789 38.7749 248.554C38.7749 254.318 34.0131 259.065 28.2308 259.065ZM28.2308 242.789C24.8295 242.789 22.1085 245.502 22.1085 248.893C22.1085 252.284 24.8295 254.996 28.2308 254.996C31.6322 254.996 34.3532 252.284 34.3532 248.893C34.0131 245.163 31.6322 242.789 28.2308 242.789Z"
      fill="#45D09C"
    />
    <path
      d="M211.222 340.447C224.183 340.447 234.691 329.972 234.691 317.05C234.691 304.128 224.183 293.653 211.222 293.653C198.26 293.653 187.753 304.128 187.753 317.05C187.753 329.972 198.26 340.447 211.222 340.447Z"
      fill="#8FE3BE"
    />
    <path
      d="M218.863 303.256L200.344 321.718L206.116 327.473L224.635 309.01L218.863 303.256Z"
      stroke="#333333"
      strokeWidth="0.6051"
      strokeMiterlimit="9.9999"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M206.12 327.223L198.977 328.579L200.337 321.458"
      stroke="#333333"
      strokeWidth="0.6051"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M215.984 305.86L219.725 309.59"
      stroke="#333333"
      strokeWidth="0.6051"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M327.547 340.447C340.508 340.447 351.016 329.972 351.016 317.05C351.016 304.128 340.508 293.653 327.547 293.653C314.585 293.653 304.078 304.128 304.078 317.05C304.078 329.972 314.585 340.447 327.547 340.447Z"
      fill="#8FE3BE"
    />
    <path
      d="M323.465 320.78L329.927 333.326L339.111 305.521L311.22 314.337L323.465 320.78Z"
      stroke="#333333"
      strokeWidth="0.6051"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M323.465 321.119L339.111 305.521"
      stroke="#333333"
      strokeWidth="0.6051"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M269.384 340.447C282.346 340.447 292.853 329.972 292.853 317.05C292.853 304.128 282.346 293.653 269.384 293.653C256.422 293.653 245.915 304.128 245.915 317.05C245.915 329.972 256.422 340.447 269.384 340.447Z"
      fill="#8FE3BE"
    />
    <path
      d="M282.989 308.573H255.779V326.884H282.989V308.573Z"
      stroke="#333333"
      strokeWidth="0.6051"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M282.989 308.573L269.384 319.085L255.779 308.573"
      stroke="#333333"
      strokeWidth="0.6051"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M255.779 326.884L264.282 315.015"
      stroke="#333333"
      strokeWidth="0.6051"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M282.989 326.884L274.146 315.015"
      stroke="#333333"
      strokeWidth="0.6051"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M385.709 340.447C398.671 340.447 409.178 329.972 409.178 317.05C409.178 304.128 398.671 293.653 385.709 293.653C372.747 293.653 362.24 304.128 362.24 317.05C362.24 329.972 372.747 340.447 385.709 340.447Z"
      fill="#8FE3BE"
    />
    <path
      d="M398.634 325.866H377.546L372.444 329.257V308.234H398.634V325.866Z"
      stroke="#333333"
      strokeWidth="0.6051"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M381.287 318.406C382.039 318.406 382.648 317.799 382.648 317.05C382.648 316.301 382.039 315.694 381.287 315.694C380.536 315.694 379.927 316.301 379.927 317.05C379.927 317.799 380.536 318.406 381.287 318.406Z"
      fill="#333333"
    />
    <path
      d="M385.709 318.406C386.46 318.406 387.07 317.799 387.07 317.05C387.07 316.301 386.46 315.694 385.709 315.694C384.958 315.694 384.349 316.301 384.349 317.05C384.349 317.799 384.958 318.406 385.709 318.406Z"
      fill="#333333"
    />
    <path
      d="M390.131 318.406C390.882 318.406 391.491 317.799 391.491 317.05C391.491 316.301 390.882 315.694 390.131 315.694C389.379 315.694 388.77 316.301 388.77 317.05C388.77 317.799 389.379 318.406 390.131 318.406Z"
      fill="#333333"
    />
    <path
      d="M111.563 250.927H122.107C123.808 250.927 125.168 249.571 125.168 247.875V237.364C125.168 235.668 123.808 234.312 122.107 234.312H111.563C109.862 234.312 108.502 235.668 108.502 237.364V247.875C108.842 249.91 109.862 250.927 111.563 250.927Z"
      stroke="#FF9B00"
      strokeWidth="0.6829"
      strokeMiterlimit="10"
    />
    <path
      d="M115.645 240.076L120.066 245.502L131.631 233.973"
      stroke="#FF9B00"
      strokeWidth="0.6829"
      strokeMiterlimit="10"
    />
    <path
      d="M134.352 242.789H164.624"
      stroke="#FF9B00"
      strokeWidth="0.6829"
      strokeMiterlimit="10"
    />
    <path
      d="M111.563 276.698H122.107C123.808 276.698 125.168 275.342 125.168 273.646V263.135C125.168 261.439 123.808 260.083 122.107 260.083H111.563C109.862 260.083 108.502 261.439 108.502 263.135V273.646C108.842 275.342 109.862 276.698 111.563 276.698Z"
      stroke="#FF9B00"
      strokeWidth="0.6829"
      strokeMiterlimit="10"
    />
    <path
      d="M115.645 265.847L120.066 271.273L131.631 259.744"
      stroke="#FF9B00"
      strokeWidth="0.6829"
      strokeMiterlimit="10"
    />
    <path d="M134.352 268.56H164.624" stroke="#FF9B00" strokeWidth="0.6829" strokeMiterlimit="10" />
    <path
      d="M111.563 302.469H122.107C123.808 302.469 125.168 301.113 125.168 299.417V288.905C125.168 287.21 123.808 285.854 122.107 285.854H111.563C109.862 285.854 108.502 287.21 108.502 288.905V299.417C108.842 301.113 109.862 302.469 111.563 302.469Z"
      stroke="#FF9B00"
      strokeWidth="0.6829"
      strokeMiterlimit="10"
    />
    <path
      d="M115.645 291.279L120.066 296.705L131.631 285.175"
      stroke="#FF9B00"
      strokeWidth="0.6829"
      strokeMiterlimit="10"
    />
    <path
      d="M134.352 293.992H164.624"
      stroke="#FF9B00"
      strokeWidth="0.6829"
      strokeMiterlimit="10"
    />
    <path
      d="M190 131.416C190 127.068 192.352 123.06 196.148 120.939L288.648 69.2689C292.285 67.2374 296.715 67.2374 300.352 69.2689L392.852 120.939C396.648 123.06 399 127.068 399 131.416V228.584C399 232.932 396.648 236.94 392.852 239.061L300.352 290.731C296.715 292.763 292.285 292.763 288.648 290.731L196.148 239.061C192.352 236.94 190 232.932 190 228.584V131.416Z"
      fill="#FFE4E0"
    />
    <path
      opacity="0.75"
      d="M198 135.559C198 131.207 200.356 127.196 204.158 125.077L288.158 78.2565C291.79 76.2321 296.21 76.2321 299.842 78.2565L383.842 125.077C387.644 127.196 390 131.207 390 135.559V223.441C390 227.793 387.644 231.804 383.842 233.923L299.842 280.744C296.21 282.768 291.79 282.768 288.158 280.744L204.158 233.923C200.356 231.804 198 227.793 198 223.441V135.559Z"
      fill="#F8351A"
    />
    <path
      opacity="0.1"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M293 282.22V76.7799C295.341 76.5843 297.725 77.0765 299.842 78.2565L383.842 125.077C387.644 127.196 390 131.207 390 135.559V223.441C390 227.793 387.644 231.804 383.842 233.923L299.842 280.744C297.725 281.923 295.341 282.416 293 282.22Z"
      fill="#1C1B1B"
    />
    <path
      d="M238.371 202.66C235.328 202.66 232.376 202.257 229.516 201.45C226.693 200.607 224.42 199.525 222.696 198.205L225.721 191.495C227.371 192.705 229.333 193.677 231.606 194.41C233.88 195.143 236.153 195.51 238.426 195.51C240.956 195.51 242.826 195.143 244.036 194.41C245.246 193.64 245.851 192.632 245.851 191.385C245.851 190.468 245.485 189.717 244.751 189.13C244.055 188.507 243.138 188.012 242.001 187.645C240.901 187.278 239.398 186.875 237.491 186.435C234.558 185.738 232.156 185.042 230.286 184.345C228.416 183.648 226.803 182.53 225.446 180.99C224.126 179.45 223.466 177.397 223.466 174.83C223.466 172.593 224.071 170.577 225.281 168.78C226.491 166.947 228.306 165.498 230.726 164.435C233.183 163.372 236.171 162.84 239.691 162.84C242.148 162.84 244.55 163.133 246.896 163.72C249.243 164.307 251.296 165.15 253.056 166.25L250.306 173.015C246.75 170.998 243.193 169.99 239.636 169.99C237.143 169.99 235.291 170.393 234.081 171.2C232.908 172.007 232.321 173.07 232.321 174.39C232.321 175.71 233 176.7 234.356 177.36C235.75 177.983 237.858 178.607 240.681 179.23C243.615 179.927 246.016 180.623 247.886 181.32C249.756 182.017 251.351 183.117 252.671 184.62C254.028 186.123 254.706 188.158 254.706 190.725C254.706 192.925 254.083 194.942 252.836 196.775C251.626 198.572 249.793 200.002 247.336 201.065C244.88 202.128 241.891 202.66 238.371 202.66ZM268.232 170.76H255.912V163.5H289.462V170.76H277.142V202H268.232V170.76ZM312.364 202.66C308.368 202.66 304.756 201.798 301.529 200.075C298.339 198.352 295.828 195.987 293.994 192.98C292.198 189.937 291.299 186.527 291.299 182.75C291.299 178.973 292.198 175.582 293.994 172.575C295.828 169.532 298.339 167.148 301.529 165.425C304.756 163.702 308.368 162.84 312.364 162.84C316.361 162.84 319.954 163.702 323.144 165.425C326.334 167.148 328.846 169.532 330.679 172.575C332.513 175.582 333.429 178.973 333.429 182.75C333.429 186.527 332.513 189.937 330.679 192.98C328.846 195.987 326.334 198.352 323.144 200.075C319.954 201.798 316.361 202.66 312.364 202.66ZM312.364 195.07C314.638 195.07 316.691 194.557 318.524 193.53C320.358 192.467 321.788 191 322.814 189.13C323.878 187.26 324.409 185.133 324.409 182.75C324.409 180.367 323.878 178.24 322.814 176.37C321.788 174.5 320.358 173.052 318.524 172.025C316.691 170.962 314.638 170.43 312.364 170.43C310.091 170.43 308.038 170.962 306.204 172.025C304.371 173.052 302.923 174.5 301.859 176.37C300.833 178.24 300.319 180.367 300.319 182.75C300.319 185.133 300.833 187.26 301.859 189.13C302.923 191 304.371 192.467 306.204 193.53C308.038 194.557 310.091 195.07 312.364 195.07ZM356.791 163.5C360.201 163.5 363.152 164.068 365.646 165.205C368.176 166.342 370.119 167.955 371.476 170.045C372.832 172.135 373.511 174.61 373.511 177.47C373.511 180.293 372.832 182.768 371.476 184.895C370.119 186.985 368.176 188.598 365.646 189.735C363.152 190.835 360.201 191.385 356.791 191.385H349.036V202H340.126V163.5H356.791ZM356.296 184.125C358.972 184.125 361.007 183.557 362.401 182.42C363.794 181.247 364.491 179.597 364.491 177.47C364.491 175.307 363.794 173.657 362.401 172.52C361.007 171.347 358.972 170.76 356.296 170.76H349.036V184.125H356.296Z"
      fill="white"
    />
  </svg>
);

export const LEFT_DOTS = (
  <svg
    width="766"
    height="524"
    viewBox="0 0 766 524"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.62">
      <path
        opacity="0.62"
        d="M2.21591 147.159C3.43973 147.159 4.43182 146.167 4.43182 144.943C4.43182 143.719 3.43973 142.726 2.21591 142.726C0.992096 142.726 0 143.719 0 144.943C0 146.167 0.992096 147.159 2.21591 147.159Z"
        fill="#80CE9D"
      />
      <path
        opacity="0.62"
        d="M34.2704 147.159C35.4942 147.159 36.4863 146.167 36.4863 144.943C36.4863 143.719 35.4942 142.726 34.2704 142.726C33.0466 142.726 32.0545 143.719 32.0545 144.943C32.0545 146.167 33.0466 147.159 34.2704 147.159Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M66.325 147.159C67.5488 147.159 68.5409 146.167 68.5409 144.943C68.5409 143.719 67.5488 142.726 66.325 142.726C65.1012 142.726 64.1091 143.719 64.1091 144.943C64.1091 146.167 65.1012 147.159 66.325 147.159Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M100.596 144.943C100.596 145.531 100.362 146.095 99.9466 146.51C99.531 146.926 98.9673 147.16 98.3796 147.16C98.0889 147.16 97.8012 147.102 97.5327 146.991C97.2642 146.879 97.0204 146.716 96.8152 146.51C96.61 146.304 96.4474 146.059 96.3368 145.791C96.2262 145.522 96.1698 145.234 96.1707 144.943C96.1707 144.356 96.4032 143.793 96.8172 143.378C97.2313 142.963 97.7931 142.728 98.3796 142.726C98.9673 142.726 99.531 142.96 99.9466 143.375C100.362 143.791 100.596 144.355 100.596 144.943Z"
        fill="#80CE9D"
      />
      <path
        opacity="0.62"
        d="M130.441 147.159C131.665 147.159 132.657 146.167 132.657 144.943C132.657 143.719 131.665 142.726 130.441 142.726C129.217 142.726 128.225 143.719 128.225 144.943C128.225 146.167 129.217 147.159 130.441 147.159Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M162.503 147.159C163.726 147.159 164.718 146.167 164.718 144.943C164.718 143.719 163.726 142.726 162.503 142.726C161.279 142.726 160.287 143.719 160.287 144.943C160.287 146.167 161.279 147.159 162.503 147.159Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M194.557 147.159C195.781 147.159 196.773 146.167 196.773 144.943C196.773 143.719 195.781 142.726 194.557 142.726C193.333 142.726 192.341 143.719 192.341 144.943C192.341 146.167 193.333 147.159 194.557 147.159Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M226.612 147.159C227.835 147.159 228.828 146.167 228.828 144.943C228.828 143.719 227.835 142.726 226.612 142.726C225.388 142.726 224.396 143.719 224.396 144.943C224.396 146.167 225.388 147.159 226.612 147.159Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M258.673 147.159C259.897 147.159 260.889 146.167 260.889 144.943C260.889 143.719 259.897 142.726 258.673 142.726C257.449 142.726 256.457 143.719 256.457 144.943C256.457 146.167 257.449 147.159 258.673 147.159Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M2.21591 168.716C3.43973 168.716 4.43182 167.723 4.43182 166.499C4.43182 165.275 3.43973 164.282 2.21591 164.282C0.992096 164.282 0 165.275 0 166.499C0 167.723 0.992096 168.716 2.21591 168.716Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M34.2704 168.716C35.4942 168.716 36.4863 167.723 36.4863 166.499C36.4863 165.275 35.4942 164.282 34.2704 164.282C33.0466 164.282 32.0545 165.275 32.0545 166.499C32.0545 167.723 33.0466 168.716 34.2704 168.716Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M66.325 168.716C67.5488 168.716 68.5409 167.723 68.5409 166.499C68.5409 165.275 67.5488 164.282 66.325 164.282C65.1012 164.282 64.1091 165.275 64.1091 166.499C64.1091 167.723 65.1012 168.716 66.325 168.716Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M100.596 166.499C100.596 167.087 100.362 167.651 99.9466 168.066C99.531 168.482 98.9673 168.716 98.3796 168.716C98.0889 168.716 97.8012 168.658 97.5327 168.547C97.2642 168.435 97.0204 168.272 96.8152 168.066C96.61 167.86 96.4474 167.616 96.3368 167.347C96.2262 167.078 96.1698 166.79 96.1707 166.499C96.1698 166.208 96.2262 165.92 96.3368 165.651C96.4474 165.382 96.61 165.138 96.8152 164.932C97.0204 164.726 97.2642 164.563 97.5327 164.451C97.8012 164.34 98.0889 164.282 98.3796 164.282C98.9673 164.282 99.531 164.516 99.9466 164.932C100.362 165.347 100.596 165.911 100.596 166.499Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M130.441 168.716C131.665 168.716 132.657 167.723 132.657 166.499C132.657 165.275 131.665 164.282 130.441 164.282C129.217 164.282 128.225 165.275 128.225 166.499C128.225 167.723 129.217 168.716 130.441 168.716Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M162.503 168.716C163.726 168.716 164.718 167.723 164.718 166.499C164.718 165.275 163.726 164.282 162.503 164.282C161.279 164.282 160.287 165.275 160.287 166.499C160.287 167.723 161.279 168.716 162.503 168.716Z"
        fill="#80CE9D"
      />
      <path
        opacity="0.62"
        d="M194.557 168.716C195.781 168.716 196.773 167.723 196.773 166.499C196.773 165.275 195.781 164.282 194.557 164.282C193.333 164.282 192.341 165.275 192.341 166.499C192.341 167.723 193.333 168.716 194.557 168.716Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M226.612 168.716C227.835 168.716 228.828 167.723 228.828 166.499C228.828 165.275 227.835 164.282 226.612 164.282C225.388 164.282 224.396 165.275 224.396 166.499C224.396 167.723 225.388 168.716 226.612 168.716Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M258.673 168.716C259.897 168.716 260.889 167.723 260.889 166.499C260.889 165.275 259.897 164.282 258.673 164.282C257.449 164.282 256.457 165.275 256.457 166.499C256.457 167.723 257.449 168.716 258.673 168.716Z"
        fill="#80CE9D"
      />
      <path
        opacity="0.62"
        d="M2.21591 190.272C3.43973 190.272 4.43182 189.279 4.43182 188.055C4.43182 186.831 3.43973 185.839 2.21591 185.839C0.992096 185.839 0 186.831 0 188.055C0 189.279 0.992096 190.272 2.21591 190.272Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M34.2704 190.272C35.4942 190.272 36.4863 189.279 36.4863 188.055C36.4863 186.831 35.4942 185.839 34.2704 185.839C33.0466 185.839 32.0545 186.831 32.0545 188.055C32.0545 189.279 33.0466 190.272 34.2704 190.272Z"
        fill="#80CE9D"
      />
      <path
        opacity="0.62"
        d="M66.325 190.272C67.5488 190.272 68.5409 189.279 68.5409 188.055C68.5409 186.831 67.5488 185.839 66.325 185.839C65.1012 185.839 64.1091 186.831 64.1091 188.055C64.1091 189.279 65.1012 190.272 66.325 190.272Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M100.596 188.055C100.596 188.643 100.362 189.207 99.9466 189.623C99.531 190.038 98.9673 190.272 98.3796 190.272C97.7931 190.27 97.2313 190.035 96.8172 189.62C96.4032 189.204 96.1707 188.642 96.1707 188.055C96.1698 187.764 96.2262 187.476 96.3368 187.207C96.4474 186.939 96.61 186.694 96.8152 186.488C97.0204 186.282 97.2642 186.119 97.5327 186.007C97.8012 185.896 98.0889 185.838 98.3796 185.839C98.9673 185.839 99.531 186.072 99.9466 186.488C100.362 186.903 100.596 187.467 100.596 188.055Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M130.441 190.272C131.665 190.272 132.657 189.279 132.657 188.055C132.657 186.831 131.665 185.839 130.441 185.839C129.217 185.839 128.225 186.831 128.225 188.055C128.225 189.279 129.217 190.272 130.441 190.272Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M162.503 190.272C163.726 190.272 164.718 189.279 164.718 188.055C164.718 186.831 163.726 185.839 162.503 185.839C161.279 185.839 160.287 186.831 160.287 188.055C160.287 189.279 161.279 190.272 162.503 190.272Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M194.557 190.272C195.781 190.272 196.773 189.279 196.773 188.055C196.773 186.831 195.781 185.839 194.557 185.839C193.333 185.839 192.341 186.831 192.341 188.055C192.341 189.279 193.333 190.272 194.557 190.272Z"
        fill="#80CE9D"
      />
      <path
        opacity="0.62"
        d="M226.612 190.272C227.835 190.272 228.828 189.279 228.828 188.055C228.828 186.831 227.835 185.839 226.612 185.839C225.388 185.839 224.396 186.831 224.396 188.055C224.396 189.279 225.388 190.272 226.612 190.272Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M258.673 190.272C259.897 190.272 260.889 189.279 260.889 188.055C260.889 186.831 259.897 185.839 258.673 185.839C257.449 185.839 256.457 186.831 256.457 188.055C256.457 189.279 257.449 190.272 258.673 190.272Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M2.21591 211.821C3.43973 211.821 4.43182 210.828 4.43182 209.604C4.43182 208.38 3.43973 207.388 2.21591 207.388C0.992096 207.388 0 208.38 0 209.604C0 210.828 0.992096 211.821 2.21591 211.821Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M34.2704 211.821C35.4942 211.821 36.4863 210.828 36.4863 209.604C36.4863 208.38 35.4942 207.388 34.2704 207.388C33.0466 207.388 32.0545 208.38 32.0545 209.604C32.0545 210.828 33.0466 211.821 34.2704 211.821Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M66.325 211.821C67.5488 211.821 68.5409 210.828 68.5409 209.604C68.5409 208.38 67.5488 207.388 66.325 207.388C65.1012 207.388 64.1091 208.38 64.1091 209.604C64.1091 210.828 65.1012 211.821 66.325 211.821Z"
        fill="#80CE9D"
      />
      <path
        opacity="0.62"
        d="M100.596 209.59C100.596 209.881 100.538 210.169 100.427 210.438C100.315 210.706 100.152 210.95 99.9461 211.155C99.7403 211.361 99.4959 211.523 99.2271 211.634C98.9583 211.744 98.6703 211.801 98.3796 211.8C97.7938 211.8 97.2319 211.567 96.8177 211.153C96.4034 210.738 96.1707 210.176 96.1707 209.59C96.1698 209.3 96.2262 209.012 96.3368 208.743C96.4474 208.474 96.61 208.229 96.8152 208.023C97.0204 207.818 97.2642 207.654 97.5327 207.543C97.8012 207.431 98.0889 207.374 98.3796 207.374C98.9673 207.374 99.531 207.607 99.9466 208.023C100.362 208.439 100.596 209.003 100.596 209.59Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M130.441 211.821C131.665 211.821 132.657 210.828 132.657 209.604C132.657 208.38 131.665 207.388 130.441 207.388C129.217 207.388 128.225 208.38 128.225 209.604C128.225 210.828 129.217 211.821 130.441 211.821Z"
        fill="#80CE9D"
      />
      <path
        opacity="0.62"
        d="M162.503 211.821C163.726 211.821 164.718 210.828 164.718 209.604C164.718 208.38 163.726 207.388 162.503 207.388C161.279 207.388 160.287 208.38 160.287 209.604C160.287 210.828 161.279 211.821 162.503 211.821Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M194.557 211.821C195.781 211.821 196.773 210.828 196.773 209.604C196.773 208.38 195.781 207.388 194.557 207.388C193.333 207.388 192.341 208.38 192.341 209.604C192.341 210.828 193.333 211.821 194.557 211.821Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M226.612 211.821C227.835 211.821 228.828 210.828 228.828 209.604C228.828 208.38 227.835 207.388 226.612 207.388C225.388 207.388 224.396 208.38 224.396 209.604C224.396 210.828 225.388 211.821 226.612 211.821Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M258.673 211.821C259.897 211.821 260.889 210.828 260.889 209.604C260.889 208.38 259.897 207.388 258.673 207.388C257.449 207.388 256.457 208.38 256.457 209.604C256.457 210.828 257.449 211.821 258.673 211.821Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M414.611 328.35C414.611 328.641 414.554 328.929 414.442 329.198C414.331 329.467 414.168 329.711 413.962 329.917C413.756 330.123 413.512 330.287 413.243 330.398C412.974 330.509 412.686 330.567 412.395 330.567C412.104 330.567 411.816 330.509 411.547 330.398C411.278 330.287 411.034 330.123 410.828 329.917C410.622 329.711 410.459 329.467 410.348 329.198C410.237 328.929 410.179 328.641 410.179 328.35C410.179 328.059 410.237 327.771 410.348 327.503C410.459 327.234 410.623 326.99 410.829 326.785C411.034 326.58 411.279 326.417 411.548 326.307C411.816 326.196 412.104 326.139 412.395 326.14C412.982 326.14 413.544 326.373 413.96 326.787C414.375 327.201 414.609 327.763 414.611 328.35Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M52.8219 24.9087C52.82 25.4953 52.5857 26.0574 52.1704 26.4716C51.755 26.8858 51.1924 27.1184 50.6059 27.1184C50.3152 27.1194 50.0273 27.0628 49.7585 26.9522C49.4897 26.8416 49.2453 26.6789 49.0395 26.4736C48.8336 26.2683 48.6703 26.0245 48.5588 25.7559C48.4474 25.4874 48.39 25.1994 48.39 24.9087C48.39 24.3208 48.6235 23.757 49.039 23.3414C49.4546 22.9257 50.0182 22.6921 50.6059 22.6921C51.1936 22.6921 51.7573 22.9257 52.1728 23.3414C52.5884 23.757 52.8219 24.3208 52.8219 24.9087Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M323.932 2.2167C323.932 2.80457 323.698 3.36833 323.283 3.78402C322.867 4.19971 322.304 4.43324 321.716 4.43324C321.128 4.43324 320.564 4.19971 320.149 3.78402C319.733 3.36833 319.5 2.80457 319.5 2.2167C319.5 1.62883 319.733 1.0649 320.149 0.649216C320.564 0.233529 321.128 0 321.716 0C322.304 0 322.867 0.233529 323.283 0.649216C323.698 1.0649 323.932 1.62883 323.932 2.2167Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M64.1161 523.643C65.3399 523.643 66.332 522.651 66.332 521.427C66.332 520.203 65.3399 519.21 64.1161 519.21C62.8922 519.21 61.9001 520.203 61.9001 521.427C61.9001 522.651 62.8922 523.643 64.1161 523.643Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M2.21591 233.377C3.43973 233.377 4.43182 232.385 4.43182 231.16C4.43182 229.936 3.43973 228.944 2.21591 228.944C0.992096 228.944 0 229.936 0 231.16C0 232.385 0.992096 233.377 2.21591 233.377Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M34.2704 233.377C35.4942 233.377 36.4863 232.385 36.4863 231.16C36.4863 229.936 35.4942 228.944 34.2704 228.944C33.0466 228.944 32.0545 229.936 32.0545 231.16C32.0545 232.385 33.0466 233.377 34.2704 233.377Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M66.325 233.377C67.5488 233.377 68.5409 232.385 68.5409 231.16C68.5409 229.936 67.5488 228.944 66.325 228.944C65.1012 228.944 64.1091 229.936 64.1091 231.16C64.1091 232.385 65.1012 233.377 66.325 233.377Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M100.596 231.16C100.596 231.748 100.362 232.312 99.9466 232.728C99.531 233.144 98.9673 233.377 98.3796 233.377C98.0889 233.377 97.8012 233.32 97.5327 233.208C97.2642 233.097 97.0204 232.933 96.8152 232.727C96.61 232.521 96.4474 232.277 96.3368 232.008C96.2262 231.739 96.1698 231.451 96.1707 231.16C96.1707 230.574 96.4034 230.012 96.8177 229.598C97.2319 229.184 97.7938 228.951 98.3796 228.951C98.6703 228.95 98.9583 229.006 99.2271 229.117C99.4959 229.228 99.7403 229.39 99.9461 229.596C100.152 229.801 100.315 230.045 100.427 230.313C100.538 230.582 100.596 230.87 100.596 231.16Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M130.441 233.377C131.665 233.377 132.657 232.385 132.657 231.16C132.657 229.936 131.665 228.944 130.441 228.944C129.217 228.944 128.225 229.936 128.225 231.16C128.225 232.385 129.217 233.377 130.441 233.377Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M162.503 233.377C163.726 233.377 164.718 232.385 164.718 231.16C164.718 229.936 163.726 228.944 162.503 228.944C161.279 228.944 160.287 229.936 160.287 231.16C160.287 232.385 161.279 233.377 162.503 233.377Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M194.557 233.377C195.781 233.377 196.773 232.385 196.773 231.16C196.773 229.936 195.781 228.944 194.557 228.944C193.333 228.944 192.341 229.936 192.341 231.16C192.341 232.385 193.333 233.377 194.557 233.377Z"
        fill="#FF9B00"
      />
      <path
        opacity="0.62"
        d="M226.612 233.377C227.835 233.377 228.828 232.385 228.828 231.16C228.828 229.936 227.835 228.944 226.612 228.944C225.388 228.944 224.396 229.936 224.396 231.16C224.396 232.385 225.388 233.377 226.612 233.377Z"
        fill="#80CE9D"
      />
      <path
        opacity="0.62"
        d="M258.673 233.377C259.897 233.377 260.889 232.385 260.889 231.16C260.889 229.936 259.897 228.944 258.673 228.944C257.449 228.944 256.457 229.936 256.457 231.16C256.457 232.385 257.449 233.377 258.673 233.377Z"
        fill="#80CE9D"
      />
      <path
        opacity="0.62"
        d="M763.576 505.703C764.799 505.703 765.792 504.711 765.792 503.487C765.792 502.262 764.799 501.27 763.576 501.27C762.352 501.27 761.36 502.262 761.36 503.487C761.36 504.711 762.352 505.703 763.576 505.703Z"
        fill="#80CE9D"
      />
      <path
        opacity="0.62"
        d="M652.233 99.1292C652.234 99.4199 652.177 99.708 652.067 99.9769C651.956 100.246 651.794 100.49 651.588 100.696C651.383 100.902 651.139 101.065 650.871 101.177C650.603 101.288 650.315 101.346 650.024 101.346C649.436 101.346 648.873 101.112 648.457 100.696C648.042 100.281 647.808 99.717 647.808 99.1292C647.808 98.5413 648.042 97.9775 648.457 97.5618C648.873 97.1462 649.436 96.9126 650.024 96.9126C650.315 96.9126 650.603 96.9699 650.871 97.0814C651.139 97.1929 651.383 97.3563 651.588 97.5622C651.794 97.7681 651.956 98.0125 652.067 98.2814C652.177 98.5503 652.234 98.8384 652.233 99.1292Z"
        fill="#80CE9D"
      />
    </g>
  </svg>
);

export const RIGHT_DOTS = (
  <svg
    width="331"
    height="415"
    viewBox="0 0 331 415"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.62"
      d="M183.484 2.21594C183.484 3.43976 184.476 4.43185 185.701 4.43185C186.925 4.43185 187.917 3.43976 187.917 2.21594C187.917 0.992127 186.925 3.04742e-05 185.701 3.04207e-05C184.476 3.03672e-05 183.484 0.992127 183.484 2.21594Z"
      fill="#80CE9D"
    />
    <path
      opacity="0.62"
      d="M183.484 34.2705C183.484 35.4943 184.476 36.4864 185.701 36.4864C186.925 36.4864 187.917 35.4943 187.917 34.2705C187.917 33.0467 186.925 32.0546 185.701 32.0546C184.476 32.0546 183.484 33.0467 183.484 34.2705Z"
      fill="#FF9B00"
    />
    <path
      opacity="0.62"
      d="M183.484 66.325C183.484 67.5489 184.476 68.541 185.701 68.541C186.925 68.541 187.917 67.5489 187.917 66.325C187.917 65.1012 186.925 64.1091 185.701 64.1091C184.476 64.1091 183.484 65.1012 183.484 66.325Z"
      fill="#FF9B00"
    />
    <path
      opacity="0.62"
      d="M185.701 100.596C185.113 100.596 184.549 100.362 184.133 99.9466C183.718 99.531 183.484 98.9673 183.484 98.3796C183.484 98.0889 183.541 97.8012 183.653 97.5327C183.764 97.2642 183.928 97.0204 184.134 96.8152C184.34 96.61 184.584 96.4474 184.853 96.3368C185.122 96.2262 185.41 96.1698 185.701 96.1707C186.287 96.1707 186.85 96.4032 187.265 96.8172C187.681 97.2313 187.915 97.7931 187.917 98.3796C187.917 98.9673 187.684 99.531 187.268 99.9466C186.852 100.362 186.289 100.596 185.701 100.596Z"
      fill="#80CE9D"
    />
    <path
      opacity="0.62"
      d="M183.484 130.441C183.484 131.665 184.476 132.657 185.701 132.657C186.925 132.657 187.917 131.665 187.917 130.441C187.917 129.217 186.925 128.225 185.701 128.225C184.476 128.225 183.484 129.217 183.484 130.441Z"
      fill="#FF9B00"
    />
    <path
      opacity="0.62"
      d="M183.484 162.503C183.484 163.726 184.476 164.718 185.701 164.718C186.925 164.718 187.917 163.726 187.917 162.503C187.917 161.279 186.925 160.287 185.701 160.287C184.476 160.287 183.484 161.279 183.484 162.503Z"
      fill="#FF9B00"
    />
    <path
      opacity="0.62"
      d="M183.484 194.557C183.484 195.781 184.476 196.773 185.701 196.773C186.925 196.773 187.917 195.781 187.917 194.557C187.917 193.333 186.925 192.341 185.701 192.341C184.476 192.341 183.484 193.333 183.484 194.557Z"
      fill="#FF9B00"
    />
    <path
      opacity="0.62"
      d="M183.484 226.612C183.484 227.835 184.476 228.828 185.701 228.828C186.925 228.828 187.917 227.835 187.917 226.612C187.917 225.388 186.925 224.396 185.701 224.396C184.476 224.396 183.484 225.388 183.484 226.612Z"
      fill="#FF9B00"
    />
    <path
      opacity="0.62"
      d="M183.484 258.673C183.484 259.897 184.476 260.889 185.701 260.889C186.925 260.889 187.917 259.897 187.917 258.673C187.917 257.449 186.925 256.457 185.701 256.457C184.476 256.457 183.484 257.449 183.484 258.673Z"
      fill="#FF9B00"
    />
    <path
      opacity="0.62"
      d="M161.928 2.21594C161.928 3.43976 162.92 4.43185 164.145 4.43185C165.369 4.43185 166.361 3.43976 166.361 2.21594C166.361 0.992127 165.369 3.04742e-05 164.145 3.04207e-05C162.92 3.03672e-05 161.928 0.992127 161.928 2.21594Z"
      fill="#FF9B00"
    />
    <path
      opacity="0.62"
      d="M161.928 34.2705C161.928 35.4943 162.92 36.4864 164.145 36.4864C165.369 36.4864 166.361 35.4943 166.361 34.2705C166.361 33.0467 165.369 32.0546 164.145 32.0546C162.92 32.0546 161.928 33.0467 161.928 34.2705Z"
      fill="#FF9B00"
    />
    <path
      opacity="0.62"
      d="M161.928 66.325C161.928 67.5489 162.92 68.541 164.145 68.541C165.369 68.541 166.361 67.5489 166.361 66.325C166.361 65.1012 165.369 64.1091 164.145 64.1091C162.92 64.1091 161.928 65.1012 161.928 66.325Z"
      fill="#FF9B00"
    />
    <path
      opacity="0.62"
      d="M164.145 100.596C163.557 100.596 162.993 100.362 162.577 99.9466C162.162 99.531 161.928 98.9673 161.928 98.3796C161.928 98.0889 161.985 97.8012 162.097 97.5327C162.208 97.2642 162.372 97.0204 162.578 96.8152C162.783 96.61 163.028 96.4474 163.297 96.3368C163.566 96.2262 163.854 96.1698 164.145 96.1707C164.435 96.1698 164.723 96.2262 164.992 96.3368C165.261 96.4474 165.506 96.61 165.712 96.8152C165.917 97.0204 166.081 97.2642 166.192 97.5327C166.304 97.8012 166.361 98.0889 166.361 98.3796C166.361 98.9673 166.128 99.531 165.712 99.9466C165.296 100.362 164.732 100.596 164.145 100.596Z"
      fill="#FF9B00"
    />
    <path
      opacity="0.62"
      d="M161.928 130.441C161.928 131.665 162.92 132.657 164.145 132.657C165.369 132.657 166.361 131.665 166.361 130.441C166.361 129.217 165.369 128.225 164.145 128.225C162.92 128.225 161.928 129.217 161.928 130.441Z"
      fill="#FF9B00"
    />
    <path
      opacity="0.62"
      d="M161.928 162.503C161.928 163.726 162.92 164.718 164.145 164.718C165.369 164.718 166.361 163.726 166.361 162.503C166.361 161.279 165.369 160.287 164.145 160.287C162.92 160.287 161.928 161.279 161.928 162.503Z"
      fill="#80CE9D"
    />
    <path
      opacity="0.62"
      d="M161.928 194.557C161.928 195.781 162.92 196.773 164.145 196.773C165.369 196.773 166.361 195.781 166.361 194.557C166.361 193.333 165.369 192.341 164.145 192.341C162.92 192.341 161.928 193.333 161.928 194.557Z"
      fill="#FF9B00"
    />
    <path
      opacity="0.62"
      d="M161.928 226.612C161.928 227.835 162.92 228.828 164.145 228.828C165.369 228.828 166.361 227.835 166.361 226.612C166.361 225.388 165.369 224.396 164.145 224.396C162.92 224.396 161.928 225.388 161.928 226.612Z"
      fill="#FF9B00"
    />
    <path
      opacity="0.62"
      d="M161.928 258.673C161.928 259.897 162.92 260.889 164.145 260.889C165.369 260.889 166.361 259.897 166.361 258.673C166.361 257.449 165.369 256.457 164.145 256.457C162.92 256.457 161.928 257.449 161.928 258.673Z"
      fill="#80CE9D"
    />
    <path
      opacity="0.62"
      d="M140.372 2.21594C140.372 3.43976 141.364 4.43185 142.588 4.43185C143.813 4.43185 144.805 3.43976 144.805 2.21594C144.805 0.992127 143.813 3.04742e-05 142.588 3.04207e-05C141.364 3.03672e-05 140.372 0.992127 140.372 2.21594Z"
      fill="#FF9B00"
    />
    <path
      opacity="0.62"
      d="M140.372 34.2704C140.372 35.4943 141.364 36.4864 142.588 36.4864C143.813 36.4864 144.805 35.4943 144.805 34.2704C144.805 33.0466 143.813 32.0545 142.588 32.0545C141.364 32.0545 140.372 33.0466 140.372 34.2704Z"
      fill="#80CE9D"
    />
    <path
      opacity="0.62"
      d="M140.372 66.325C140.372 67.5489 141.364 68.541 142.588 68.541C143.813 68.541 144.805 67.5489 144.805 66.325C144.805 65.1012 143.813 64.1091 142.588 64.1091C141.364 64.1091 140.372 65.1012 140.372 66.325Z"
      fill="#FF9B00"
    />
    <path
      opacity="0.62"
      d="M142.589 100.596C142.001 100.596 141.437 100.362 141.021 99.9466C140.605 99.531 140.372 98.9673 140.372 98.3796C140.374 97.7931 140.608 97.2313 141.024 96.8172C141.439 96.4032 142.002 96.1707 142.589 96.1707C142.879 96.1698 143.167 96.2262 143.436 96.3368C143.705 96.4474 143.949 96.61 144.155 96.8152C144.361 97.0204 144.525 97.2642 144.636 97.5327C144.748 97.8012 144.805 98.0889 144.805 98.3796C144.805 98.9673 144.572 99.531 144.156 99.9466C143.74 100.362 143.176 100.596 142.589 100.596Z"
      fill="#FF9B00"
    />
    <path
      opacity="0.62"
      d="M140.372 130.441C140.372 131.665 141.364 132.657 142.588 132.657C143.813 132.657 144.805 131.665 144.805 130.441C144.805 129.217 143.813 128.225 142.588 128.225C141.364 128.225 140.372 129.217 140.372 130.441Z"
      fill="#FF9B00"
    />
    <path
      opacity="0.62"
      d="M140.372 162.503C140.372 163.726 141.364 164.718 142.588 164.718C143.813 164.718 144.805 163.726 144.805 162.503C144.805 161.279 143.813 160.287 142.588 160.287C141.364 160.287 140.372 161.279 140.372 162.503Z"
      fill="#FF9B00"
    />
    <path
      opacity="0.62"
      d="M140.372 194.557C140.372 195.781 141.364 196.773 142.588 196.773C143.813 196.773 144.805 195.781 144.805 194.557C144.805 193.333 143.813 192.341 142.588 192.341C141.364 192.341 140.372 193.333 140.372 194.557Z"
      fill="#80CE9D"
    />
    <path
      opacity="0.62"
      d="M140.372 226.612C140.372 227.835 141.364 228.828 142.588 228.828C143.813 228.828 144.805 227.835 144.805 226.612C144.805 225.388 143.813 224.396 142.588 224.396C141.364 224.396 140.372 225.388 140.372 226.612Z"
      fill="#FF9B00"
    />
    <path
      opacity="0.62"
      d="M140.372 258.673C140.372 259.897 141.364 260.889 142.588 260.889C143.813 260.889 144.805 259.897 144.805 258.673C144.805 257.449 143.813 256.457 142.588 256.457C141.364 256.457 140.372 257.449 140.372 258.673Z"
      fill="#FF9B00"
    />
    <path
      opacity="0.62"
      d="M118.823 2.21594C118.823 3.43976 119.815 4.43185 121.039 4.43185C122.263 4.43185 123.256 3.43976 123.256 2.21594C123.256 0.992127 122.263 3.04742e-05 121.039 3.04207e-05C119.815 3.03672e-05 118.823 0.992127 118.823 2.21594Z"
      fill="#FF9B00"
    />
    <path
      opacity="0.62"
      d="M118.823 34.2704C118.823 35.4943 119.815 36.4864 121.039 36.4864C122.263 36.4864 123.256 35.4943 123.256 34.2704C123.256 33.0466 122.263 32.0545 121.039 32.0545C119.815 32.0545 118.823 33.0466 118.823 34.2704Z"
      fill="#FF9B00"
    />
    <path
      opacity="0.62"
      d="M118.823 66.325C118.823 67.5489 119.815 68.541 121.039 68.541C122.263 68.541 123.256 67.5489 123.256 66.325C123.256 65.1012 122.263 64.1091 121.039 64.1091C119.815 64.1091 118.823 65.1012 118.823 66.325Z"
      fill="#80CE9D"
    />
    <path
      opacity="0.62"
      d="M121.053 100.596C120.762 100.596 120.474 100.538 120.206 100.427C119.937 100.315 119.693 100.152 119.488 99.9461C119.283 99.7403 119.12 99.4959 119.01 99.2271C118.899 98.9583 118.843 98.6703 118.844 98.3796C118.844 97.7938 119.076 97.2319 119.491 96.8177C119.905 96.4034 120.467 96.1707 121.053 96.1707C121.344 96.1698 121.632 96.2262 121.901 96.3368C122.17 96.4474 122.414 96.61 122.62 96.8152C122.826 97.0204 122.989 97.2642 123.101 97.5327C123.212 97.8012 123.27 98.0889 123.27 98.3796C123.27 98.9673 123.036 99.531 122.62 99.9466C122.205 100.362 121.641 100.596 121.053 100.596Z"
      fill="#FF9B00"
    />
    <path
      opacity="0.62"
      d="M118.823 130.441C118.823 131.665 119.815 132.657 121.039 132.657C122.263 132.657 123.256 131.665 123.256 130.441C123.256 129.217 122.263 128.225 121.039 128.225C119.815 128.225 118.823 129.217 118.823 130.441Z"
      fill="#80CE9D"
    />
    <path
      opacity="0.62"
      d="M118.823 162.503C118.823 163.726 119.815 164.718 121.039 164.718C122.263 164.718 123.256 163.726 123.256 162.503C123.256 161.279 122.263 160.287 121.039 160.287C119.815 160.287 118.823 161.279 118.823 162.503Z"
      fill="#FF9B00"
    />
    <path
      opacity="0.62"
      d="M118.823 194.557C118.823 195.781 119.815 196.773 121.039 196.773C122.263 196.773 123.256 195.781 123.256 194.557C123.256 193.333 122.263 192.341 121.039 192.341C119.815 192.341 118.823 193.333 118.823 194.557Z"
      fill="#FF9B00"
    />
    <path
      opacity="0.62"
      d="M118.823 226.612C118.823 227.835 119.815 228.828 121.039 228.828C122.263 228.828 123.256 227.835 123.256 226.612C123.256 225.388 122.263 224.396 121.039 224.396C119.815 224.396 118.823 225.388 118.823 226.612Z"
      fill="#FF9B00"
    />
    <path
      opacity="0.62"
      d="M118.823 258.673C118.823 259.897 119.815 260.889 121.039 260.889C122.263 260.889 123.256 259.897 123.256 258.673C123.256 257.449 122.263 256.457 121.039 256.457C119.815 256.457 118.823 257.449 118.823 258.673Z"
      fill="#FF9B00"
    />
    <path
      opacity="0.62"
      d="M2.29355 414.611C2.00246 414.611 1.71421 414.554 1.44528 414.442C1.17635 414.331 0.932045 414.168 0.726216 413.962C0.520387 413.756 0.356994 413.512 0.2456 413.243C0.134207 412.974 0.0769957 412.686 0.0769958 412.395C0.0769958 412.104 0.134207 411.816 0.2456 411.547C0.356994 411.278 0.520388 411.034 0.726217 410.828C0.932045 410.623 1.17635 410.459 1.44528 410.348C1.71421 410.237 2.00246 410.179 2.29355 410.179C2.58431 410.179 2.87226 410.237 3.1408 410.348C3.40934 410.46 3.65323 410.623 3.85851 410.829C4.06378 411.035 4.22629 411.279 4.33693 411.548C4.44756 411.817 4.50407 412.104 4.50316 412.395C4.50317 412.982 4.27067 413.544 3.85648 413.96C3.44229 414.375 2.88022 414.609 2.29355 414.611Z"
      fill="#FF9B00"
    />
    <path
      opacity="0.62"
      d="M305.735 52.8219C305.148 52.8201 304.586 52.5858 304.172 52.1704C303.758 51.755 303.525 51.1924 303.525 50.6059C303.524 50.3153 303.581 50.0273 303.691 49.7585C303.802 49.4897 303.965 49.2453 304.17 49.0395C304.375 48.8336 304.619 48.6703 304.888 48.5589C305.156 48.4474 305.444 48.39 305.735 48.39C306.323 48.39 306.887 48.6235 307.302 49.0391C307.718 49.4546 307.951 50.0182 307.951 50.6059C307.951 51.1936 307.718 51.7573 307.302 52.1729C306.887 52.5884 306.323 52.8219 305.735 52.8219Z"
      fill="#FF9B00"
    />
    <path
      opacity="0.62"
      d="M328.427 323.932C327.839 323.932 327.275 323.698 326.86 323.283C326.444 322.867 326.21 322.304 326.21 321.716C326.21 321.128 326.444 320.564 326.86 320.149C327.275 319.733 327.839 319.5 328.427 319.5C329.015 319.5 329.579 319.733 329.994 320.149C330.41 320.564 330.644 321.128 330.644 321.716C330.644 322.304 330.41 322.867 329.994 323.283C329.579 323.698 329.015 323.932 328.427 323.932Z"
      fill="#FF9B00"
    />
    <path
      opacity="0.62"
      d="M97.2665 2.21594C97.2665 3.43976 98.2589 4.43185 99.4831 4.43185C100.707 4.43185 101.7 3.43976 101.7 2.21594C101.7 0.992127 100.707 3.04742e-05 99.4831 3.04207e-05C98.2589 3.03672e-05 97.2665 0.992127 97.2665 2.21594Z"
      fill="#FF9B00"
    />
    <path
      opacity="0.62"
      d="M97.2665 34.2704C97.2665 35.4943 98.2589 36.4864 99.4831 36.4864C100.707 36.4864 101.7 35.4943 101.7 34.2704C101.7 33.0466 100.707 32.0545 99.4831 32.0545C98.2589 32.0545 97.2665 33.0466 97.2665 34.2704Z"
      fill="#FF9B00"
    />
    <path
      opacity="0.62"
      d="M97.2665 66.325C97.2665 67.5489 98.2589 68.541 99.4831 68.541C100.707 68.541 101.7 67.5489 101.7 66.325C101.7 65.1012 100.707 64.1091 99.4831 64.1091C98.2589 64.1091 97.2665 65.1012 97.2665 66.325Z"
      fill="#FF9B00"
    />
    <path
      opacity="0.62"
      d="M99.4831 100.596C98.8953 100.596 98.3313 100.362 97.9157 99.9466C97.5 99.531 97.2664 98.9673 97.2664 98.3796C97.2664 98.0889 97.3239 97.8012 97.4354 97.5327C97.5469 97.2642 97.7103 97.0204 97.9162 96.8152C98.1221 96.61 98.3665 96.4474 98.6354 96.3368C98.9043 96.2262 99.1924 96.1698 99.4831 96.1707C100.069 96.1707 100.631 96.4034 101.046 96.8177C101.46 97.2319 101.693 97.7938 101.693 98.3796C101.694 98.6703 101.637 98.9583 101.527 99.2271C101.416 99.4959 101.253 99.7403 101.048 99.9461C100.843 100.152 100.599 100.315 100.33 100.427C100.062 100.538 99.7739 100.596 99.4831 100.596Z"
      fill="#FF9B00"
    />
    <path
      opacity="0.62"
      d="M97.2665 130.441C97.2665 131.665 98.2589 132.657 99.4831 132.657C100.707 132.657 101.7 131.665 101.7 130.441C101.7 129.217 100.707 128.225 99.4831 128.225C98.2589 128.225 97.2665 129.217 97.2665 130.441Z"
      fill="#FF9B00"
    />
    <path
      opacity="0.62"
      d="M97.2665 162.503C97.2665 163.726 98.2589 164.718 99.4831 164.718C100.707 164.718 101.7 163.726 101.7 162.503C101.7 161.279 100.707 160.287 99.4831 160.287C98.2589 160.287 97.2665 161.279 97.2665 162.503Z"
      fill="#FF9B00"
    />
    <path
      opacity="0.62"
      d="M97.2665 194.557C97.2665 195.781 98.2589 196.773 99.4831 196.773C100.707 196.773 101.7 195.781 101.7 194.557C101.7 193.333 100.707 192.341 99.4831 192.341C98.2589 192.341 97.2665 193.333 97.2665 194.557Z"
      fill="#FF9B00"
    />
    <path
      opacity="0.62"
      d="M97.2665 226.612C97.2665 227.835 98.2589 228.828 99.4831 228.828C100.707 228.828 101.7 227.835 101.7 226.612C101.7 225.388 100.707 224.396 99.4831 224.396C98.2589 224.396 97.2665 225.388 97.2665 226.612Z"
      fill="#80CE9D"
    />
    <path
      opacity="0.62"
      d="M97.2665 258.673C97.2665 259.897 98.2589 260.889 99.4831 260.889C100.707 260.889 101.7 259.897 101.7 258.673C101.7 257.449 100.707 256.457 99.4831 256.457C98.2589 256.457 97.2665 257.449 97.2665 258.673Z"
      fill="#80CE9D"
    />
  </svg>
);
